// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner_interaction.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Any, Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { EnvironmentClass, EnvironmentClassValidationResult, FieldValueUpdate, HostAuthenticationTokenSource, LLMIntegration, RunnerConfigurationSchema, SCMIntegration, SCMIntegrationValidationResult } from "./runner_configuration_pb.js";
import { BigPaginationRequest, PaginationRequest, PaginationResponse } from "./pagination_pb.js";
import { EnvironmentActivitySignal, EnvironmentMetadata, EnvironmentSpec, EnvironmentStatus } from "./environment_pb.js";
import { CheckAuthenticationForHostResponse, CheckRepositoryAccessResponse, GatewayInfo, ListSCMOrganizationsResponse_SCMOrganization, LogLevel, ParseContextURLResponse, RunnerCapability, RunnerReleaseChannel, SearchMode, SearchRepositoriesResponse_Repository } from "./runner_pb.js";
import { AgentExecution, AgentExecution_Status, SupportedModel, UserInputBlock } from "./agent_pb.js";
import { Integration } from "./integration_pb.js";

/**
 * SnapshotPhase represents the lifecycle phase of a snapshot
 *
 * @generated from enum gitpod.v1.RunnerEnvironmentSnapshotPhase
 */
export enum RunnerEnvironmentSnapshotPhase {
  /**
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Pending means the snapshot creation request is queued
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_PENDING = 10;
   */
  PENDING = 10,

  /**
   * Creating means the snapshot is currently being created
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_CREATING = 20;
   */
  CREATING = 20,

  /**
   * Available means the snapshot is ready for use
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_AVAILABLE = 30;
   */
  AVAILABLE = 30,

  /**
   * Failed means the snapshot creation failed
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_FAILED = 40;
   */
  FAILED = 40,

  /**
   * Deleting means the snapshot is being deleted
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_DELETING = 50;
   */
  DELETING = 50,

  /**
   * Deleted means the snapshot has been deleted
   *
   * @generated from enum value: RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_DELETED = 60;
   */
  DELETED = 60,
}
// Retrieve enum metadata with: proto3.getEnumType(RunnerEnvironmentSnapshotPhase)
proto3.util.setEnumType(RunnerEnvironmentSnapshotPhase, "gitpod.v1.RunnerEnvironmentSnapshotPhase", [
  { no: 0, name: "RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_UNSPECIFIED" },
  { no: 10, name: "RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_PENDING" },
  { no: 20, name: "RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_CREATING" },
  { no: 30, name: "RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_AVAILABLE" },
  { no: 40, name: "RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_FAILED" },
  { no: 50, name: "RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_DELETING" },
  { no: 60, name: "RUNNER_ENVIRONMENT_SNAPSHOT_PHASE_DELETED" },
]);

/**
 * @generated from message gitpod.v1.SignupRequest
 */
export class SignupRequest extends Message<SignupRequest> {
  /**
   * The runner's public key. Must be an ECDH public key encoded in PKIX, ASN.1 DER format.
   *
   * @generated from field: bytes public_key = 1;
   */
  publicKey = new Uint8Array(0);

  /**
   * The environment classes this runner has to offer
   *
   * @generated from field: repeated gitpod.v1.EnvironmentClass environment_classes = 2;
   */
  environmentClasses: EnvironmentClass[] = [];

  constructor(data?: PartialMessage<SignupRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SignupRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "public_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "environment_classes", kind: "message", T: EnvironmentClass, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignupRequest {
    return new SignupRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignupRequest {
    return new SignupRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignupRequest {
    return new SignupRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SignupRequest | PlainMessage<SignupRequest> | undefined, b: SignupRequest | PlainMessage<SignupRequest> | undefined): boolean {
    return proto3.util.equals(SignupRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SignupResponse
 */
export class SignupResponse extends Message<SignupResponse> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  constructor(data?: PartialMessage<SignupResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SignupResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SignupResponse {
    return new SignupResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SignupResponse {
    return new SignupResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SignupResponse {
    return new SignupResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SignupResponse | PlainMessage<SignupResponse> | undefined, b: SignupResponse | PlainMessage<SignupResponse> | undefined): boolean {
    return proto3.util.equals(SignupResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.MarkRunnerActiveRequest
 */
export class MarkRunnerActiveRequest extends Message<MarkRunnerActiveRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  constructor(data?: PartialMessage<MarkRunnerActiveRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.MarkRunnerActiveRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkRunnerActiveRequest {
    return new MarkRunnerActiveRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkRunnerActiveRequest {
    return new MarkRunnerActiveRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkRunnerActiveRequest {
    return new MarkRunnerActiveRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MarkRunnerActiveRequest | PlainMessage<MarkRunnerActiveRequest> | undefined, b: MarkRunnerActiveRequest | PlainMessage<MarkRunnerActiveRequest> | undefined): boolean {
    return proto3.util.equals(MarkRunnerActiveRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.MarkRunnerActiveResponse
 */
export class MarkRunnerActiveResponse extends Message<MarkRunnerActiveResponse> {
  constructor(data?: PartialMessage<MarkRunnerActiveResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.MarkRunnerActiveResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkRunnerActiveResponse {
    return new MarkRunnerActiveResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkRunnerActiveResponse {
    return new MarkRunnerActiveResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkRunnerActiveResponse {
    return new MarkRunnerActiveResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MarkRunnerActiveResponse | PlainMessage<MarkRunnerActiveResponse> | undefined, b: MarkRunnerActiveResponse | PlainMessage<MarkRunnerActiveResponse> | undefined): boolean {
    return proto3.util.equals(MarkRunnerActiveResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentsRequest
 */
export class ListRunnerEnvironmentsRequest extends Message<ListRunnerEnvironmentsRequest> {
  /**
   * pagination contains the pagination options for listing environments
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identifier
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  /**
   * An optional list of environment IDs to fetch. If this list is empty/not provided
   * all environments that ought to run on the runner are returned.
   *
   * @generated from field: repeated string environment_ids = 3;
   */
  environmentIds: string[] = [];

  constructor(data?: PartialMessage<ListRunnerEnvironmentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerEnvironmentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "environment_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerEnvironmentsRequest {
    return new ListRunnerEnvironmentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentsRequest {
    return new ListRunnerEnvironmentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentsRequest {
    return new ListRunnerEnvironmentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerEnvironmentsRequest | PlainMessage<ListRunnerEnvironmentsRequest> | undefined, b: ListRunnerEnvironmentsRequest | PlainMessage<ListRunnerEnvironmentsRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerEnvironmentsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerEnvironment
 */
export class RunnerEnvironment extends Message<RunnerEnvironment> {
  /**
   * ID is a unique identifier of this environment. No other environment with the same name must be managed by this
   * environment manager
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Metadata is data associated with this environment that's required for other parts of Gitpod to function
   *
   * @generated from field: gitpod.v1.EnvironmentMetadata metadata = 2;
   */
  metadata?: EnvironmentMetadata;

  /**
   * Spec is the configuration of the environment that's required for the runner to start the environment
   *
   * @generated from field: gitpod.v1.EnvironmentSpec spec = 3;
   */
  spec?: EnvironmentSpec;

  /**
   * The environment's access token
   *
   * @generated from field: string environment_access_token = 4;
   */
  environmentAccessToken = "";

  /**
   * The last activity signal received by the management plane
   *
   * @generated from field: gitpod.v1.EnvironmentActivitySignal activity_signal = 5;
   */
  activitySignal?: EnvironmentActivitySignal;

  /**
   * The SCM contexts for the environment
   *
   * @generated from field: repeated gitpod.v1.SCMContext scm_contexts = 6;
   */
  scmContexts: SCMContext[] = [];

  /**
   * startup_trace_context contains trace headers for the root startup trace
   * to propagate trace context to runners for end-to-end tracing
   *
   * @generated from field: map<string, string> startup_trace_context = 7;
   */
  startupTraceContext: { [key: string]: string } = {};

  /**
   * snapshot_id specifies an existing environment snapshot to use when creating the environment.
   * If present, the runner will attempt to use the referenced snapshot to create the environment,
   * and otherwise fall back to normal environment creation.
   *
   * @generated from field: string snapshot_id = 8;
   */
  snapshotId = "";

  constructor(data?: PartialMessage<RunnerEnvironment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerEnvironment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: EnvironmentMetadata },
    { no: 3, name: "spec", kind: "message", T: EnvironmentSpec },
    { no: 4, name: "environment_access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "activity_signal", kind: "message", T: EnvironmentActivitySignal },
    { no: 6, name: "scm_contexts", kind: "message", T: SCMContext, repeated: true },
    { no: 7, name: "startup_trace_context", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "snapshot_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerEnvironment {
    return new RunnerEnvironment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerEnvironment {
    return new RunnerEnvironment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerEnvironment {
    return new RunnerEnvironment().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerEnvironment | PlainMessage<RunnerEnvironment> | undefined, b: RunnerEnvironment | PlainMessage<RunnerEnvironment> | undefined): boolean {
    return proto3.util.equals(RunnerEnvironment, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SCMContext
 */
export class SCMContext extends Message<SCMContext> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: string host = 2;
   */
  host = "";

  /**
   * @generated from field: string username = 3;
   */
  username = "";

  /**
   * @generated from field: string email = 4;
   */
  email = "";

  /**
   * @generated from field: string remote_uri = 5;
   */
  remoteUri = "";

  constructor(data?: PartialMessage<SCMContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SCMContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "remote_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SCMContext {
    return new SCMContext().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SCMContext {
    return new SCMContext().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SCMContext {
    return new SCMContext().fromJsonString(jsonString, options);
  }

  static equals(a: SCMContext | PlainMessage<SCMContext> | undefined, b: SCMContext | PlainMessage<SCMContext> | undefined): boolean {
    return proto3.util.equals(SCMContext, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentsResponse
 */
export class ListRunnerEnvironmentsResponse extends Message<ListRunnerEnvironmentsResponse> {
  /**
   * pagination contains the pagination options for listing environments
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The environments running on the runner
   *
   * @generated from field: repeated gitpod.v1.RunnerEnvironment environments = 2;
   */
  environments: RunnerEnvironment[] = [];

  constructor(data?: PartialMessage<ListRunnerEnvironmentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerEnvironmentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "environments", kind: "message", T: RunnerEnvironment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerEnvironmentsResponse {
    return new ListRunnerEnvironmentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentsResponse {
    return new ListRunnerEnvironmentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentsResponse {
    return new ListRunnerEnvironmentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerEnvironmentsResponse | PlainMessage<ListRunnerEnvironmentsResponse> | undefined, b: ListRunnerEnvironmentsResponse | PlainMessage<ListRunnerEnvironmentsResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerEnvironmentsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerEnvironmentRequest
 */
export class GetRunnerEnvironmentRequest extends Message<GetRunnerEnvironmentRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The environment's ID
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId = "";

  constructor(data?: PartialMessage<GetRunnerEnvironmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerEnvironmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerEnvironmentRequest {
    return new GetRunnerEnvironmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerEnvironmentRequest {
    return new GetRunnerEnvironmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerEnvironmentRequest {
    return new GetRunnerEnvironmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerEnvironmentRequest | PlainMessage<GetRunnerEnvironmentRequest> | undefined, b: GetRunnerEnvironmentRequest | PlainMessage<GetRunnerEnvironmentRequest> | undefined): boolean {
    return proto3.util.equals(GetRunnerEnvironmentRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerEnvironmentResponse
 */
export class GetRunnerEnvironmentResponse extends Message<GetRunnerEnvironmentResponse> {
  /**
   * @generated from field: gitpod.v1.RunnerEnvironment environment = 1;
   */
  environment?: RunnerEnvironment;

  constructor(data?: PartialMessage<GetRunnerEnvironmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerEnvironmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment", kind: "message", T: RunnerEnvironment },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerEnvironmentResponse {
    return new GetRunnerEnvironmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerEnvironmentResponse {
    return new GetRunnerEnvironmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerEnvironmentResponse {
    return new GetRunnerEnvironmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerEnvironmentResponse | PlainMessage<GetRunnerEnvironmentResponse> | undefined, b: GetRunnerEnvironmentResponse | PlainMessage<GetRunnerEnvironmentResponse> | undefined): boolean {
    return proto3.util.equals(GetRunnerEnvironmentResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerEnvironmentStatusRequest
 */
export class UpdateRunnerEnvironmentStatusRequest extends Message<UpdateRunnerEnvironmentStatusRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The environment's ID
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId = "";

  /**
   * The environment's status
   *
   * @generated from field: gitpod.v1.EnvironmentStatus status = 3;
   */
  status?: EnvironmentStatus;

  constructor(data?: PartialMessage<UpdateRunnerEnvironmentStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerEnvironmentStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "message", T: EnvironmentStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerEnvironmentStatusRequest {
    return new UpdateRunnerEnvironmentStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerEnvironmentStatusRequest {
    return new UpdateRunnerEnvironmentStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerEnvironmentStatusRequest {
    return new UpdateRunnerEnvironmentStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerEnvironmentStatusRequest | PlainMessage<UpdateRunnerEnvironmentStatusRequest> | undefined, b: UpdateRunnerEnvironmentStatusRequest | PlainMessage<UpdateRunnerEnvironmentStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerEnvironmentStatusRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerEnvironmentStatusResponse
 */
export class UpdateRunnerEnvironmentStatusResponse extends Message<UpdateRunnerEnvironmentStatusResponse> {
  constructor(data?: PartialMessage<UpdateRunnerEnvironmentStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerEnvironmentStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerEnvironmentStatusResponse {
    return new UpdateRunnerEnvironmentStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerEnvironmentStatusResponse {
    return new UpdateRunnerEnvironmentStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerEnvironmentStatusResponse {
    return new UpdateRunnerEnvironmentStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerEnvironmentStatusResponse | PlainMessage<UpdateRunnerEnvironmentStatusResponse> | undefined, b: UpdateRunnerEnvironmentStatusResponse | PlainMessage<UpdateRunnerEnvironmentStatusResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerEnvironmentStatusResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerStatusRequest
 */
export class UpdateRunnerStatusRequest extends Message<UpdateRunnerStatusRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * version is the version of the runner. This is used to detect if the runner is outdated.
   *
   * @generated from field: optional string version = 2;
   */
  version?: string;

  /**
   * system_details is a runner specific system detail string. Think of this like a user agent string.
   * It's intended to be used for debugging and support purposes and might be shown to the user.
   *
   * @generated from field: optional string system_details = 4;
   */
  systemDetails?: string;

  /**
   * log_url is the URL to the runner's logs
   *
   * @generated from field: optional string log_url = 5;
   */
  logUrl?: string;

  /**
   * Degredation message is an optional message that is shown to users when the runner is in a degraded state.
   * Setting this to "" changes the runner's phase back from "degraded" to "active".
   *
   * @generated from field: optional string degredation_message = 6;
   */
  degredationMessage?: string;

  /**
   * region is the region the runner is running in, if applicable.
   *
   * @generated from field: optional string region = 7;
   */
  region?: string;

  /**
   * additional_info updates fields in the runner's additional_info.
   *
   * @generated from field: repeated gitpod.v1.FieldValueUpdate additional_info = 8;
   */
  additionalInfo: FieldValueUpdate[] = [];

  /**
   * capabilities contains the runner's supported capabilities.
   * Optional field, only overwrites previous capabilities if set to a non-empty list.
   * To clear capabilities, set this to a list with a single UNSPECIFIED capability.
   *
   * @generated from field: repeated gitpod.v1.RunnerCapability capabilities = 9;
   */
  capabilities: RunnerCapability[] = [];

  /**
   * GatewayInfo contains information about the gateway that the runner is running on.
   *
   * @generated from field: gitpod.v1.GatewayInfo gateway_info = 10;
   */
  gatewayInfo?: GatewayInfo;

  /**
   * llm_url is the URL of the LLM service to which the runner is connected.
   *
   * @generated from field: optional string llm_url = 11;
   */
  llmUrl?: string;

  /**
   * @generated from field: optional string support_bundle_url = 12;
   */
  supportBundleUrl?: string;

  constructor(data?: PartialMessage<UpdateRunnerStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "system_details", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "log_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "degredation_message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "additional_info", kind: "message", T: FieldValueUpdate, repeated: true },
    { no: 9, name: "capabilities", kind: "enum", T: proto3.getEnumType(RunnerCapability), repeated: true },
    { no: 10, name: "gateway_info", kind: "message", T: GatewayInfo },
    { no: 11, name: "llm_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "support_bundle_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerStatusRequest {
    return new UpdateRunnerStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerStatusRequest {
    return new UpdateRunnerStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerStatusRequest {
    return new UpdateRunnerStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerStatusRequest | PlainMessage<UpdateRunnerStatusRequest> | undefined, b: UpdateRunnerStatusRequest | PlainMessage<UpdateRunnerStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerStatusRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerStatusResponse
 */
export class UpdateRunnerStatusResponse extends Message<UpdateRunnerStatusResponse> {
  constructor(data?: PartialMessage<UpdateRunnerStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerStatusResponse {
    return new UpdateRunnerStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerStatusResponse {
    return new UpdateRunnerStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerStatusResponse {
    return new UpdateRunnerStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerStatusResponse | PlainMessage<UpdateRunnerStatusResponse> | undefined, b: UpdateRunnerStatusResponse | PlainMessage<UpdateRunnerStatusResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerStatusResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerConfigurationSchemaRequest
 */
export class UpdateRunnerConfigurationSchemaRequest extends Message<UpdateRunnerConfigurationSchemaRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * config_schema is the schema for the runner's configuration
   *
   * @generated from field: gitpod.v1.RunnerConfigurationSchema config_schema = 2;
   */
  configSchema?: RunnerConfigurationSchema;

  constructor(data?: PartialMessage<UpdateRunnerConfigurationSchemaRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerConfigurationSchemaRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "config_schema", kind: "message", T: RunnerConfigurationSchema },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerConfigurationSchemaRequest {
    return new UpdateRunnerConfigurationSchemaRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerConfigurationSchemaRequest {
    return new UpdateRunnerConfigurationSchemaRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerConfigurationSchemaRequest {
    return new UpdateRunnerConfigurationSchemaRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerConfigurationSchemaRequest | PlainMessage<UpdateRunnerConfigurationSchemaRequest> | undefined, b: UpdateRunnerConfigurationSchemaRequest | PlainMessage<UpdateRunnerConfigurationSchemaRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerConfigurationSchemaRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerConfigurationSchemaResponse
 */
export class UpdateRunnerConfigurationSchemaResponse extends Message<UpdateRunnerConfigurationSchemaResponse> {
  constructor(data?: PartialMessage<UpdateRunnerConfigurationSchemaResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerConfigurationSchemaResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerConfigurationSchemaResponse {
    return new UpdateRunnerConfigurationSchemaResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerConfigurationSchemaResponse {
    return new UpdateRunnerConfigurationSchemaResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerConfigurationSchemaResponse {
    return new UpdateRunnerConfigurationSchemaResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerConfigurationSchemaResponse | PlainMessage<UpdateRunnerConfigurationSchemaResponse> | undefined, b: UpdateRunnerConfigurationSchemaResponse | PlainMessage<UpdateRunnerConfigurationSchemaResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerConfigurationSchemaResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetHostAuthenticationTokenValueRequest
 */
export class GetHostAuthenticationTokenValueRequest extends Message<GetHostAuthenticationTokenValueRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The principal's ID to get the authentication token for
   *
   * @generated from field: string principal_id = 2;
   */
  principalId = "";

  /**
   * The host to get the authentication token for
   *
   * @generated from field: string host = 3;
   */
  host = "";

  constructor(data?: PartialMessage<GetHostAuthenticationTokenValueRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetHostAuthenticationTokenValueRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetHostAuthenticationTokenValueRequest {
    return new GetHostAuthenticationTokenValueRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetHostAuthenticationTokenValueRequest {
    return new GetHostAuthenticationTokenValueRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetHostAuthenticationTokenValueRequest {
    return new GetHostAuthenticationTokenValueRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetHostAuthenticationTokenValueRequest | PlainMessage<GetHostAuthenticationTokenValueRequest> | undefined, b: GetHostAuthenticationTokenValueRequest | PlainMessage<GetHostAuthenticationTokenValueRequest> | undefined): boolean {
    return proto3.util.equals(GetHostAuthenticationTokenValueRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetHostAuthenticationTokenValueResponse
 */
export class GetHostAuthenticationTokenValueResponse extends Message<GetHostAuthenticationTokenValueResponse> {
  /**
   * The authentication token encrypted as NaCL anonymous sealed box using the runner's public key
   *
   * @generated from field: bytes value = 1;
   */
  value = new Uint8Array(0);

  /**
   * The host authentication token's ID
   *
   * @generated from field: string token_id = 2;
   */
  tokenId = "";

  /**
   * The host authentication token's expiry
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;

  /**
   * The host authentication token's refresh token encrypted as NaCL anonymous sealed box using the runner's public key
   *
   * @generated from field: bytes refresh_token = 4;
   */
  refreshToken = new Uint8Array(0);

  /**
   * The host authentication token's source
   *
   * @generated from field: gitpod.v1.HostAuthenticationTokenSource source = 5;
   */
  source = HostAuthenticationTokenSource.UNSPECIFIED;

  constructor(data?: PartialMessage<GetHostAuthenticationTokenValueResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetHostAuthenticationTokenValueResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "token_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expires_at", kind: "message", T: Timestamp },
    { no: 4, name: "refresh_token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "source", kind: "enum", T: proto3.getEnumType(HostAuthenticationTokenSource) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetHostAuthenticationTokenValueResponse {
    return new GetHostAuthenticationTokenValueResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetHostAuthenticationTokenValueResponse {
    return new GetHostAuthenticationTokenValueResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetHostAuthenticationTokenValueResponse {
    return new GetHostAuthenticationTokenValueResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetHostAuthenticationTokenValueResponse | PlainMessage<GetHostAuthenticationTokenValueResponse> | undefined, b: GetHostAuthenticationTokenValueResponse | PlainMessage<GetHostAuthenticationTokenValueResponse> | undefined): boolean {
    return proto3.util.equals(GetHostAuthenticationTokenValueResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentClassesRequest
 */
export class ListRunnerEnvironmentClassesRequest extends Message<ListRunnerEnvironmentClassesRequest> {
  /**
   * pagination contains the pagination options for listing environment classes
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  /**
   * @generated from field: gitpod.v1.ListRunnerEnvironmentClassesRequest.Filter filter = 3;
   */
  filter?: ListRunnerEnvironmentClassesRequest_Filter;

  constructor(data?: PartialMessage<ListRunnerEnvironmentClassesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerEnvironmentClassesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "message", T: ListRunnerEnvironmentClassesRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerEnvironmentClassesRequest {
    return new ListRunnerEnvironmentClassesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentClassesRequest {
    return new ListRunnerEnvironmentClassesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentClassesRequest {
    return new ListRunnerEnvironmentClassesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerEnvironmentClassesRequest | PlainMessage<ListRunnerEnvironmentClassesRequest> | undefined, b: ListRunnerEnvironmentClassesRequest | PlainMessage<ListRunnerEnvironmentClassesRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerEnvironmentClassesRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentClassesRequest.Filter
 */
export class ListRunnerEnvironmentClassesRequest_Filter extends Message<ListRunnerEnvironmentClassesRequest_Filter> {
  /**
   * environment_class_ids filters the response to only environment classes with these IDs
   *
   * @generated from field: repeated string environment_class_ids = 1;
   */
  environmentClassIds: string[] = [];

  constructor(data?: PartialMessage<ListRunnerEnvironmentClassesRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerEnvironmentClassesRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_class_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerEnvironmentClassesRequest_Filter {
    return new ListRunnerEnvironmentClassesRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentClassesRequest_Filter {
    return new ListRunnerEnvironmentClassesRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentClassesRequest_Filter {
    return new ListRunnerEnvironmentClassesRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerEnvironmentClassesRequest_Filter | PlainMessage<ListRunnerEnvironmentClassesRequest_Filter> | undefined, b: ListRunnerEnvironmentClassesRequest_Filter | PlainMessage<ListRunnerEnvironmentClassesRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListRunnerEnvironmentClassesRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentClassesResponse
 */
export class ListRunnerEnvironmentClassesResponse extends Message<ListRunnerEnvironmentClassesResponse> {
  /**
   * pagination contains the pagination options for listing environment classes
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The environment classes configured for the runner
   *
   * @generated from field: repeated gitpod.v1.EnvironmentClass environment_classes = 2;
   */
  environmentClasses: EnvironmentClass[] = [];

  constructor(data?: PartialMessage<ListRunnerEnvironmentClassesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerEnvironmentClassesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "environment_classes", kind: "message", T: EnvironmentClass, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerEnvironmentClassesResponse {
    return new ListRunnerEnvironmentClassesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentClassesResponse {
    return new ListRunnerEnvironmentClassesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentClassesResponse {
    return new ListRunnerEnvironmentClassesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerEnvironmentClassesResponse | PlainMessage<ListRunnerEnvironmentClassesResponse> | undefined, b: ListRunnerEnvironmentClassesResponse | PlainMessage<ListRunnerEnvironmentClassesResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerEnvironmentClassesResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerSCMIntegrationsRequest
 */
export class ListRunnerSCMIntegrationsRequest extends Message<ListRunnerSCMIntegrationsRequest> {
  /**
   * pagination contains the pagination options for listing SCM integrations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  /**
   * @generated from field: gitpod.v1.ListRunnerSCMIntegrationsRequest.Filter filter = 3;
   */
  filter?: ListRunnerSCMIntegrationsRequest_Filter;

  constructor(data?: PartialMessage<ListRunnerSCMIntegrationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerSCMIntegrationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "message", T: ListRunnerSCMIntegrationsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerSCMIntegrationsRequest {
    return new ListRunnerSCMIntegrationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerSCMIntegrationsRequest {
    return new ListRunnerSCMIntegrationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerSCMIntegrationsRequest {
    return new ListRunnerSCMIntegrationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerSCMIntegrationsRequest | PlainMessage<ListRunnerSCMIntegrationsRequest> | undefined, b: ListRunnerSCMIntegrationsRequest | PlainMessage<ListRunnerSCMIntegrationsRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerSCMIntegrationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerSCMIntegrationsRequest.Filter
 */
export class ListRunnerSCMIntegrationsRequest_Filter extends Message<ListRunnerSCMIntegrationsRequest_Filter> {
  /**
   * environment_class_ids filters the response to only SCM integrations with these IDs
   *
   * @generated from field: repeated string scm_integration_ids = 1;
   */
  scmIntegrationIds: string[] = [];

  constructor(data?: PartialMessage<ListRunnerSCMIntegrationsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerSCMIntegrationsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scm_integration_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerSCMIntegrationsRequest_Filter {
    return new ListRunnerSCMIntegrationsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerSCMIntegrationsRequest_Filter {
    return new ListRunnerSCMIntegrationsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerSCMIntegrationsRequest_Filter {
    return new ListRunnerSCMIntegrationsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerSCMIntegrationsRequest_Filter | PlainMessage<ListRunnerSCMIntegrationsRequest_Filter> | undefined, b: ListRunnerSCMIntegrationsRequest_Filter | PlainMessage<ListRunnerSCMIntegrationsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListRunnerSCMIntegrationsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerSCMIntegrationsResponse
 */
export class ListRunnerSCMIntegrationsResponse extends Message<ListRunnerSCMIntegrationsResponse> {
  /**
   * pagination contains the pagination options for listing SCM integrations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The SCM integrations configured for the runner
   *
   * @generated from field: repeated gitpod.v1.SCMIntegration scm_integrations = 2;
   */
  scmIntegrations: SCMIntegration[] = [];

  constructor(data?: PartialMessage<ListRunnerSCMIntegrationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerSCMIntegrationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "scm_integrations", kind: "message", T: SCMIntegration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerSCMIntegrationsResponse {
    return new ListRunnerSCMIntegrationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerSCMIntegrationsResponse {
    return new ListRunnerSCMIntegrationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerSCMIntegrationsResponse {
    return new ListRunnerSCMIntegrationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerSCMIntegrationsResponse | PlainMessage<ListRunnerSCMIntegrationsResponse> | undefined, b: ListRunnerSCMIntegrationsResponse | PlainMessage<ListRunnerSCMIntegrationsResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerSCMIntegrationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WatchRequestsRequest
 */
export class WatchRequestsRequest extends Message<WatchRequestsRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  constructor(data?: PartialMessage<WatchRequestsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WatchRequestsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WatchRequestsRequest {
    return new WatchRequestsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WatchRequestsRequest {
    return new WatchRequestsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WatchRequestsRequest {
    return new WatchRequestsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: WatchRequestsRequest | PlainMessage<WatchRequestsRequest> | undefined, b: WatchRequestsRequest | PlainMessage<WatchRequestsRequest> | undefined): boolean {
    return proto3.util.equals(WatchRequestsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WatchRequestsResponse
 */
export class WatchRequestsResponse extends Message<WatchRequestsResponse> {
  /**
   * The request's ID
   *
   * @generated from field: string request_id = 1;
   */
  requestId = "";

  /**
   * The request to handle
   *
   * @generated from oneof gitpod.v1.WatchRequestsResponse.request
   */
  request: {
    /**
     * @generated from field: gitpod.v1.EventEnvironmentSpecChange event_environment_spec_change = 10;
     */
    value: EventEnvironmentSpecChange;
    case: "eventEnvironmentSpecChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventEnvironmentMarkedActive event_environment_marked_active = 11;
     */
    value: EventEnvironmentMarkedActive;
    case: "eventEnvironmentMarkedActive";
  } | {
    /**
     * @generated from field: gitpod.v1.EventSCMIntegrationChange event_scm_integration_change = 12;
     */
    value: EventSCMIntegrationChange;
    case: "eventScmIntegrationChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventHostAuthenticationTokenDeleted event_host_authentication_token_deleted = 13;
     */
    value: EventHostAuthenticationTokenDeleted;
    case: "eventHostAuthenticationTokenDeleted";
  } | {
    /**
     * @generated from field: gitpod.v1.EventAgentExecutionSpecChange event_agent_execution_spec_change = 14;
     */
    value: EventAgentExecutionSpecChange;
    case: "eventAgentExecutionSpecChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventLLMIntegrationChange event_llm_integration_change = 15;
     */
    value: EventLLMIntegrationChange;
    case: "eventLlmIntegrationChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventRunnerConfigurationChange event_runner_configuration_change = 16;
     */
    value: EventRunnerConfigurationChange;
    case: "eventRunnerConfigurationChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventIntegrationChange event_integration_change = 17;
     */
    value: EventIntegrationChange;
    case: "eventIntegrationChange";
  } | {
    /**
     * @generated from field: gitpod.v1.EventSnapshotSpecChange event_snapshot_spec_change = 18;
     */
    value: EventSnapshotSpecChange;
    case: "eventSnapshotSpecChange";
  } | {
    /**
     * @generated from field: gitpod.v1.CallParseContext.Request call_parse_context = 50;
     */
    value: CallParseContext_Request;
    case: "callParseContext";
  } | {
    /**
     * @generated from field: gitpod.v1.CallPing.Request call_ping = 51;
     */
    value: CallPing_Request;
    case: "callPing";
  } | {
    /**
     * @generated from field: gitpod.v1.CallCheckAuthenticationForHost.Request call_check_authentication_for_host = 52;
     */
    value: CallCheckAuthenticationForHost_Request;
    case: "callCheckAuthenticationForHost";
  } | {
    /**
     * @generated from field: gitpod.v1.CallValidateConfig.Request call_validate_config = 53;
     */
    value: CallValidateConfig_Request;
    case: "callValidateConfig";
  } | {
    /**
     * @generated from field: gitpod.v1.CallSendMessageToAgentExecution.Request call_send_message_to_agent_execution = 54;
     */
    value: CallSendMessageToAgentExecution_Request;
    case: "callSendMessageToAgentExecution";
  } | {
    /**
     * @generated from field: gitpod.v1.CallImprovePromptForAgent.Request call_improve_prompt_for_agent = 55;
     */
    value: CallImprovePromptForAgent_Request;
    case: "callImprovePromptForAgent";
  } | {
    /**
     * @generated from field: gitpod.v1.CallSearchRepositories.Request call_search_repositories = 60;
     */
    value: CallSearchRepositories_Request;
    case: "callSearchRepositories";
  } | {
    /**
     * @generated from field: gitpod.v1.CallListSCMOrganizations.Request call_list_scm_organizations = 61;
     */
    value: CallListSCMOrganizations_Request;
    case: "callListScmOrganizations";
  } | {
    /**
     * @generated from field: gitpod.v1.CallCheckRepositoryAccess.Request call_check_repository_access = 62;
     */
    value: CallCheckRepositoryAccess_Request;
    case: "callCheckRepositoryAccess";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<WatchRequestsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WatchRequestsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "event_environment_spec_change", kind: "message", T: EventEnvironmentSpecChange, oneof: "request" },
    { no: 11, name: "event_environment_marked_active", kind: "message", T: EventEnvironmentMarkedActive, oneof: "request" },
    { no: 12, name: "event_scm_integration_change", kind: "message", T: EventSCMIntegrationChange, oneof: "request" },
    { no: 13, name: "event_host_authentication_token_deleted", kind: "message", T: EventHostAuthenticationTokenDeleted, oneof: "request" },
    { no: 14, name: "event_agent_execution_spec_change", kind: "message", T: EventAgentExecutionSpecChange, oneof: "request" },
    { no: 15, name: "event_llm_integration_change", kind: "message", T: EventLLMIntegrationChange, oneof: "request" },
    { no: 16, name: "event_runner_configuration_change", kind: "message", T: EventRunnerConfigurationChange, oneof: "request" },
    { no: 17, name: "event_integration_change", kind: "message", T: EventIntegrationChange, oneof: "request" },
    { no: 18, name: "event_snapshot_spec_change", kind: "message", T: EventSnapshotSpecChange, oneof: "request" },
    { no: 50, name: "call_parse_context", kind: "message", T: CallParseContext_Request, oneof: "request" },
    { no: 51, name: "call_ping", kind: "message", T: CallPing_Request, oneof: "request" },
    { no: 52, name: "call_check_authentication_for_host", kind: "message", T: CallCheckAuthenticationForHost_Request, oneof: "request" },
    { no: 53, name: "call_validate_config", kind: "message", T: CallValidateConfig_Request, oneof: "request" },
    { no: 54, name: "call_send_message_to_agent_execution", kind: "message", T: CallSendMessageToAgentExecution_Request, oneof: "request" },
    { no: 55, name: "call_improve_prompt_for_agent", kind: "message", T: CallImprovePromptForAgent_Request, oneof: "request" },
    { no: 60, name: "call_search_repositories", kind: "message", T: CallSearchRepositories_Request, oneof: "request" },
    { no: 61, name: "call_list_scm_organizations", kind: "message", T: CallListSCMOrganizations_Request, oneof: "request" },
    { no: 62, name: "call_check_repository_access", kind: "message", T: CallCheckRepositoryAccess_Request, oneof: "request" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WatchRequestsResponse {
    return new WatchRequestsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WatchRequestsResponse {
    return new WatchRequestsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WatchRequestsResponse {
    return new WatchRequestsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: WatchRequestsResponse | PlainMessage<WatchRequestsResponse> | undefined, b: WatchRequestsResponse | PlainMessage<WatchRequestsResponse> | undefined): boolean {
    return proto3.util.equals(WatchRequestsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SendResponseRequest
 */
export class SendResponseRequest extends Message<SendResponseRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The request's ID we're responding to
   *
   * @generated from field: string request_id = 2;
   */
  requestId = "";

  /**
   * The response to send
   *
   * @generated from oneof gitpod.v1.SendResponseRequest.response
   */
  response: {
    /**
     * @generated from field: gitpod.v1.SendResponseRequest.CallError error = 5;
     */
    value: SendResponseRequest_CallError;
    case: "error";
  } | {
    /**
     * @generated from field: gitpod.v1.CallParseContext.Response call_parse_context = 50;
     */
    value: CallParseContext_Response;
    case: "callParseContext";
  } | {
    /**
     * @generated from field: gitpod.v1.CallPing.Response call_ping = 51;
     */
    value: CallPing_Response;
    case: "callPing";
  } | {
    /**
     * @generated from field: gitpod.v1.CallCheckAuthenticationForHost.Response call_check_authentication_for_host = 52;
     */
    value: CallCheckAuthenticationForHost_Response;
    case: "callCheckAuthenticationForHost";
  } | {
    /**
     * @generated from field: gitpod.v1.CallValidateConfig.Response call_validate_config = 53;
     */
    value: CallValidateConfig_Response;
    case: "callValidateConfig";
  } | {
    /**
     * @generated from field: gitpod.v1.CallSendMessageToAgentExecution.Response call_send_message_to_agent_execution = 54;
     */
    value: CallSendMessageToAgentExecution_Response;
    case: "callSendMessageToAgentExecution";
  } | {
    /**
     * @generated from field: gitpod.v1.CallImprovePromptForAgent.Response call_improve_prompt_for_agent = 55;
     */
    value: CallImprovePromptForAgent_Response;
    case: "callImprovePromptForAgent";
  } | {
    /**
     * @generated from field: gitpod.v1.CallSearchRepositories.Response call_search_repositories = 60;
     */
    value: CallSearchRepositories_Response;
    case: "callSearchRepositories";
  } | {
    /**
     * @generated from field: gitpod.v1.CallListSCMOrganizations.Response call_list_scm_organizations = 61;
     */
    value: CallListSCMOrganizations_Response;
    case: "callListScmOrganizations";
  } | {
    /**
     * @generated from field: gitpod.v1.CallCheckRepositoryAccess.Response call_check_repository_access = 62;
     */
    value: CallCheckRepositoryAccess_Response;
    case: "callCheckRepositoryAccess";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SendResponseRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SendResponseRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "error", kind: "message", T: SendResponseRequest_CallError, oneof: "response" },
    { no: 50, name: "call_parse_context", kind: "message", T: CallParseContext_Response, oneof: "response" },
    { no: 51, name: "call_ping", kind: "message", T: CallPing_Response, oneof: "response" },
    { no: 52, name: "call_check_authentication_for_host", kind: "message", T: CallCheckAuthenticationForHost_Response, oneof: "response" },
    { no: 53, name: "call_validate_config", kind: "message", T: CallValidateConfig_Response, oneof: "response" },
    { no: 54, name: "call_send_message_to_agent_execution", kind: "message", T: CallSendMessageToAgentExecution_Response, oneof: "response" },
    { no: 55, name: "call_improve_prompt_for_agent", kind: "message", T: CallImprovePromptForAgent_Response, oneof: "response" },
    { no: 60, name: "call_search_repositories", kind: "message", T: CallSearchRepositories_Response, oneof: "response" },
    { no: 61, name: "call_list_scm_organizations", kind: "message", T: CallListSCMOrganizations_Response, oneof: "response" },
    { no: 62, name: "call_check_repository_access", kind: "message", T: CallCheckRepositoryAccess_Response, oneof: "response" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendResponseRequest {
    return new SendResponseRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendResponseRequest {
    return new SendResponseRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendResponseRequest {
    return new SendResponseRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SendResponseRequest | PlainMessage<SendResponseRequest> | undefined, b: SendResponseRequest | PlainMessage<SendResponseRequest> | undefined): boolean {
    return proto3.util.equals(SendResponseRequest, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.SendResponseRequest.ErrorCode
 */
export enum SendResponseRequest_ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_CANCELED = 1;
   */
  CANCELED = 1,

  /**
   * @generated from enum value: ERROR_CODE_INVALID_ARGUMENT = 3;
   */
  INVALID_ARGUMENT = 3,

  /**
   * @generated from enum value: ERROR_CODE_DEADLINE_EXCEEDED = 4;
   */
  DEADLINE_EXCEEDED = 4,

  /**
   * @generated from enum value: ERROR_CODE_NOT_FOUND = 5;
   */
  NOT_FOUND = 5,

  /**
   * @generated from enum value: ERROR_CODE_ALREADY_EXISTS = 6;
   */
  ALREADY_EXISTS = 6,

  /**
   * @generated from enum value: ERROR_CODE_PERMISSION_DENIED = 7;
   */
  PERMISSION_DENIED = 7,

  /**
   * @generated from enum value: ERROR_CODE_RESOURCE_EXHAUSTED = 8;
   */
  RESOURCE_EXHAUSTED = 8,

  /**
   * @generated from enum value: ERROR_CODE_FAILED_PRECONDITION = 9;
   */
  FAILED_PRECONDITION = 9,

  /**
   * @generated from enum value: ERROR_CODE_UNIMPLEMENTED = 12;
   */
  UNIMPLEMENTED = 12,

  /**
   * @generated from enum value: ERROR_CODE_UNAVAILABLE = 14;
   */
  UNAVAILABLE = 14,

  /**
   * @generated from enum value: ERROR_CODE_UNAUTHENTICATED = 16;
   */
  UNAUTHENTICATED = 16,
}
// Retrieve enum metadata with: proto3.getEnumType(SendResponseRequest_ErrorCode)
proto3.util.setEnumType(SendResponseRequest_ErrorCode, "gitpod.v1.SendResponseRequest.ErrorCode", [
  { no: 0, name: "ERROR_CODE_UNSPECIFIED" },
  { no: 1, name: "ERROR_CODE_CANCELED" },
  { no: 3, name: "ERROR_CODE_INVALID_ARGUMENT" },
  { no: 4, name: "ERROR_CODE_DEADLINE_EXCEEDED" },
  { no: 5, name: "ERROR_CODE_NOT_FOUND" },
  { no: 6, name: "ERROR_CODE_ALREADY_EXISTS" },
  { no: 7, name: "ERROR_CODE_PERMISSION_DENIED" },
  { no: 8, name: "ERROR_CODE_RESOURCE_EXHAUSTED" },
  { no: 9, name: "ERROR_CODE_FAILED_PRECONDITION" },
  { no: 12, name: "ERROR_CODE_UNIMPLEMENTED" },
  { no: 14, name: "ERROR_CODE_UNAVAILABLE" },
  { no: 16, name: "ERROR_CODE_UNAUTHENTICATED" },
]);

/**
 * @generated from message gitpod.v1.SendResponseRequest.CallError
 */
export class SendResponseRequest_CallError extends Message<SendResponseRequest_CallError> {
  /**
   * The error's code
   *
   * @generated from field: gitpod.v1.SendResponseRequest.ErrorCode code = 1;
   */
  code = SendResponseRequest_ErrorCode.UNSPECIFIED;

  /**
   * The error's message
   *
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * Error details
   *
   * @generated from field: repeated google.protobuf.Any details = 3;
   */
  details: Any[] = [];

  constructor(data?: PartialMessage<SendResponseRequest_CallError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SendResponseRequest.CallError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "enum", T: proto3.getEnumType(SendResponseRequest_ErrorCode) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "details", kind: "message", T: Any, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendResponseRequest_CallError {
    return new SendResponseRequest_CallError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendResponseRequest_CallError {
    return new SendResponseRequest_CallError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendResponseRequest_CallError {
    return new SendResponseRequest_CallError().fromJsonString(jsonString, options);
  }

  static equals(a: SendResponseRequest_CallError | PlainMessage<SendResponseRequest_CallError> | undefined, b: SendResponseRequest_CallError | PlainMessage<SendResponseRequest_CallError> | undefined): boolean {
    return proto3.util.equals(SendResponseRequest_CallError, a, b);
  }
}

/**
 * @generated from message gitpod.v1.SendResponseResponse
 */
export class SendResponseResponse extends Message<SendResponseResponse> {
  constructor(data?: PartialMessage<SendResponseResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.SendResponseResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendResponseResponse {
    return new SendResponseResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendResponseResponse {
    return new SendResponseResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendResponseResponse {
    return new SendResponseResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendResponseResponse | PlainMessage<SendResponseResponse> | undefined, b: SendResponseResponse | PlainMessage<SendResponseResponse> | undefined): boolean {
    return proto3.util.equals(SendResponseResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventEnvironmentSpecChange
 */
export class EventEnvironmentSpecChange extends Message<EventEnvironmentSpecChange> {
  /**
   * The environment's ID
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId = "";

  constructor(data?: PartialMessage<EventEnvironmentSpecChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventEnvironmentSpecChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventEnvironmentSpecChange {
    return new EventEnvironmentSpecChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventEnvironmentSpecChange {
    return new EventEnvironmentSpecChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventEnvironmentSpecChange {
    return new EventEnvironmentSpecChange().fromJsonString(jsonString, options);
  }

  static equals(a: EventEnvironmentSpecChange | PlainMessage<EventEnvironmentSpecChange> | undefined, b: EventEnvironmentSpecChange | PlainMessage<EventEnvironmentSpecChange> | undefined): boolean {
    return proto3.util.equals(EventEnvironmentSpecChange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventEnvironmentMarkedActive
 */
export class EventEnvironmentMarkedActive extends Message<EventEnvironmentMarkedActive> {
  /**
   * The environment's ID
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId = "";

  constructor(data?: PartialMessage<EventEnvironmentMarkedActive>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventEnvironmentMarkedActive";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventEnvironmentMarkedActive {
    return new EventEnvironmentMarkedActive().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventEnvironmentMarkedActive {
    return new EventEnvironmentMarkedActive().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventEnvironmentMarkedActive {
    return new EventEnvironmentMarkedActive().fromJsonString(jsonString, options);
  }

  static equals(a: EventEnvironmentMarkedActive | PlainMessage<EventEnvironmentMarkedActive> | undefined, b: EventEnvironmentMarkedActive | PlainMessage<EventEnvironmentMarkedActive> | undefined): boolean {
    return proto3.util.equals(EventEnvironmentMarkedActive, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventSCMIntegrationChange
 */
export class EventSCMIntegrationChange extends Message<EventSCMIntegrationChange> {
  /**
   * The SCM integration's ID
   *
   * @generated from field: string scm_integration_id = 1;
   */
  scmIntegrationId = "";

  constructor(data?: PartialMessage<EventSCMIntegrationChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventSCMIntegrationChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scm_integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventSCMIntegrationChange {
    return new EventSCMIntegrationChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventSCMIntegrationChange {
    return new EventSCMIntegrationChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventSCMIntegrationChange {
    return new EventSCMIntegrationChange().fromJsonString(jsonString, options);
  }

  static equals(a: EventSCMIntegrationChange | PlainMessage<EventSCMIntegrationChange> | undefined, b: EventSCMIntegrationChange | PlainMessage<EventSCMIntegrationChange> | undefined): boolean {
    return proto3.util.equals(EventSCMIntegrationChange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventLLMIntegrationChange
 */
export class EventLLMIntegrationChange extends Message<EventLLMIntegrationChange> {
  /**
   * The LLM integration's ID
   *
   * @generated from field: string llm_integration_id = 1;
   */
  llmIntegrationId = "";

  constructor(data?: PartialMessage<EventLLMIntegrationChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventLLMIntegrationChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "llm_integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventLLMIntegrationChange {
    return new EventLLMIntegrationChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventLLMIntegrationChange {
    return new EventLLMIntegrationChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventLLMIntegrationChange {
    return new EventLLMIntegrationChange().fromJsonString(jsonString, options);
  }

  static equals(a: EventLLMIntegrationChange | PlainMessage<EventLLMIntegrationChange> | undefined, b: EventLLMIntegrationChange | PlainMessage<EventLLMIntegrationChange> | undefined): boolean {
    return proto3.util.equals(EventLLMIntegrationChange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventIntegrationChange
 */
export class EventIntegrationChange extends Message<EventIntegrationChange> {
  /**
   * The integration's ID
   *
   * @generated from field: string integration_id = 1;
   */
  integrationId = "";

  constructor(data?: PartialMessage<EventIntegrationChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventIntegrationChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventIntegrationChange {
    return new EventIntegrationChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventIntegrationChange {
    return new EventIntegrationChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventIntegrationChange {
    return new EventIntegrationChange().fromJsonString(jsonString, options);
  }

  static equals(a: EventIntegrationChange | PlainMessage<EventIntegrationChange> | undefined, b: EventIntegrationChange | PlainMessage<EventIntegrationChange> | undefined): boolean {
    return proto3.util.equals(EventIntegrationChange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventSnapshotSpecChange
 */
export class EventSnapshotSpecChange extends Message<EventSnapshotSpecChange> {
  /**
   * The snapshot's ID
   *
   * @generated from field: string snapshot_id = 1;
   */
  snapshotId = "";

  constructor(data?: PartialMessage<EventSnapshotSpecChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventSnapshotSpecChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snapshot_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventSnapshotSpecChange {
    return new EventSnapshotSpecChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventSnapshotSpecChange {
    return new EventSnapshotSpecChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventSnapshotSpecChange {
    return new EventSnapshotSpecChange().fromJsonString(jsonString, options);
  }

  static equals(a: EventSnapshotSpecChange | PlainMessage<EventSnapshotSpecChange> | undefined, b: EventSnapshotSpecChange | PlainMessage<EventSnapshotSpecChange> | undefined): boolean {
    return proto3.util.equals(EventSnapshotSpecChange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventHostAuthenticationTokenDeleted
 */
export class EventHostAuthenticationTokenDeleted extends Message<EventHostAuthenticationTokenDeleted> {
  /**
   * The host authentication token's host.
   *
   * @generated from field: string host = 1;
   */
  host = "";

  /**
   * The principal ID of the deleted token.
   *
   * @generated from field: string principal_id = 2;
   */
  principalId = "";

  constructor(data?: PartialMessage<EventHostAuthenticationTokenDeleted>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventHostAuthenticationTokenDeleted";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventHostAuthenticationTokenDeleted {
    return new EventHostAuthenticationTokenDeleted().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventHostAuthenticationTokenDeleted {
    return new EventHostAuthenticationTokenDeleted().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventHostAuthenticationTokenDeleted {
    return new EventHostAuthenticationTokenDeleted().fromJsonString(jsonString, options);
  }

  static equals(a: EventHostAuthenticationTokenDeleted | PlainMessage<EventHostAuthenticationTokenDeleted> | undefined, b: EventHostAuthenticationTokenDeleted | PlainMessage<EventHostAuthenticationTokenDeleted> | undefined): boolean {
    return proto3.util.equals(EventHostAuthenticationTokenDeleted, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventAgentExecutionSpecChange
 */
export class EventAgentExecutionSpecChange extends Message<EventAgentExecutionSpecChange> {
  /**
   * The agent execution's ID
   *
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<EventAgentExecutionSpecChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventAgentExecutionSpecChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventAgentExecutionSpecChange {
    return new EventAgentExecutionSpecChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventAgentExecutionSpecChange {
    return new EventAgentExecutionSpecChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventAgentExecutionSpecChange {
    return new EventAgentExecutionSpecChange().fromJsonString(jsonString, options);
  }

  static equals(a: EventAgentExecutionSpecChange | PlainMessage<EventAgentExecutionSpecChange> | undefined, b: EventAgentExecutionSpecChange | PlainMessage<EventAgentExecutionSpecChange> | undefined): boolean {
    return proto3.util.equals(EventAgentExecutionSpecChange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.EventRunnerConfigurationChange
 */
export class EventRunnerConfigurationChange extends Message<EventRunnerConfigurationChange> {
  constructor(data?: PartialMessage<EventRunnerConfigurationChange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.EventRunnerConfigurationChange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventRunnerConfigurationChange {
    return new EventRunnerConfigurationChange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventRunnerConfigurationChange {
    return new EventRunnerConfigurationChange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventRunnerConfigurationChange {
    return new EventRunnerConfigurationChange().fromJsonString(jsonString, options);
  }

  static equals(a: EventRunnerConfigurationChange | PlainMessage<EventRunnerConfigurationChange> | undefined, b: EventRunnerConfigurationChange | PlainMessage<EventRunnerConfigurationChange> | undefined): boolean {
    return proto3.util.equals(EventRunnerConfigurationChange, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallParseContext
 */
export class CallParseContext extends Message<CallParseContext> {
  constructor(data?: PartialMessage<CallParseContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallParseContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallParseContext {
    return new CallParseContext().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallParseContext {
    return new CallParseContext().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallParseContext {
    return new CallParseContext().fromJsonString(jsonString, options);
  }

  static equals(a: CallParseContext | PlainMessage<CallParseContext> | undefined, b: CallParseContext | PlainMessage<CallParseContext> | undefined): boolean {
    return proto3.util.equals(CallParseContext, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallParseContext.Request
 */
export class CallParseContext_Request extends Message<CallParseContext_Request> {
  /**
   * @generated from field: string context_url = 1;
   */
  contextUrl = "";

  /**
   * @generated from field: string principal_id = 2;
   */
  principalId = "";

  constructor(data?: PartialMessage<CallParseContext_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallParseContext.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "context_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallParseContext_Request {
    return new CallParseContext_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallParseContext_Request {
    return new CallParseContext_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallParseContext_Request {
    return new CallParseContext_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallParseContext_Request | PlainMessage<CallParseContext_Request> | undefined, b: CallParseContext_Request | PlainMessage<CallParseContext_Request> | undefined): boolean {
    return proto3.util.equals(CallParseContext_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallParseContext.Response
 */
export class CallParseContext_Response extends Message<CallParseContext_Response> {
  /**
   * @generated from field: gitpod.v1.ParseContextURLResponse resp = 1;
   */
  resp?: ParseContextURLResponse;

  constructor(data?: PartialMessage<CallParseContext_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallParseContext.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resp", kind: "message", T: ParseContextURLResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallParseContext_Response {
    return new CallParseContext_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallParseContext_Response {
    return new CallParseContext_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallParseContext_Response {
    return new CallParseContext_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallParseContext_Response | PlainMessage<CallParseContext_Response> | undefined, b: CallParseContext_Response | PlainMessage<CallParseContext_Response> | undefined): boolean {
    return proto3.util.equals(CallParseContext_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallPing
 */
export class CallPing extends Message<CallPing> {
  constructor(data?: PartialMessage<CallPing>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallPing";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallPing {
    return new CallPing().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallPing {
    return new CallPing().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallPing {
    return new CallPing().fromJsonString(jsonString, options);
  }

  static equals(a: CallPing | PlainMessage<CallPing> | undefined, b: CallPing | PlainMessage<CallPing> | undefined): boolean {
    return proto3.util.equals(CallPing, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallPing.Request
 */
export class CallPing_Request extends Message<CallPing_Request> {
  constructor(data?: PartialMessage<CallPing_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallPing.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallPing_Request {
    return new CallPing_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallPing_Request {
    return new CallPing_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallPing_Request {
    return new CallPing_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallPing_Request | PlainMessage<CallPing_Request> | undefined, b: CallPing_Request | PlainMessage<CallPing_Request> | undefined): boolean {
    return proto3.util.equals(CallPing_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallPing.Response
 */
export class CallPing_Response extends Message<CallPing_Response> {
  constructor(data?: PartialMessage<CallPing_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallPing.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallPing_Response {
    return new CallPing_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallPing_Response {
    return new CallPing_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallPing_Response {
    return new CallPing_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallPing_Response | PlainMessage<CallPing_Response> | undefined, b: CallPing_Response | PlainMessage<CallPing_Response> | undefined): boolean {
    return proto3.util.equals(CallPing_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallCheckAuthenticationForHost
 */
export class CallCheckAuthenticationForHost extends Message<CallCheckAuthenticationForHost> {
  constructor(data?: PartialMessage<CallCheckAuthenticationForHost>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallCheckAuthenticationForHost";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallCheckAuthenticationForHost {
    return new CallCheckAuthenticationForHost().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallCheckAuthenticationForHost {
    return new CallCheckAuthenticationForHost().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallCheckAuthenticationForHost {
    return new CallCheckAuthenticationForHost().fromJsonString(jsonString, options);
  }

  static equals(a: CallCheckAuthenticationForHost | PlainMessage<CallCheckAuthenticationForHost> | undefined, b: CallCheckAuthenticationForHost | PlainMessage<CallCheckAuthenticationForHost> | undefined): boolean {
    return proto3.util.equals(CallCheckAuthenticationForHost, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallCheckAuthenticationForHost.Request
 */
export class CallCheckAuthenticationForHost_Request extends Message<CallCheckAuthenticationForHost_Request> {
  /**
   * @generated from field: string host = 1;
   */
  host = "";

  /**
   * @generated from field: string principal_id = 2;
   */
  principalId = "";

  constructor(data?: PartialMessage<CallCheckAuthenticationForHost_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallCheckAuthenticationForHost.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallCheckAuthenticationForHost_Request {
    return new CallCheckAuthenticationForHost_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallCheckAuthenticationForHost_Request {
    return new CallCheckAuthenticationForHost_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallCheckAuthenticationForHost_Request {
    return new CallCheckAuthenticationForHost_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallCheckAuthenticationForHost_Request | PlainMessage<CallCheckAuthenticationForHost_Request> | undefined, b: CallCheckAuthenticationForHost_Request | PlainMessage<CallCheckAuthenticationForHost_Request> | undefined): boolean {
    return proto3.util.equals(CallCheckAuthenticationForHost_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallCheckAuthenticationForHost.Response
 */
export class CallCheckAuthenticationForHost_Response extends Message<CallCheckAuthenticationForHost_Response> {
  /**
   * @generated from field: gitpod.v1.CheckAuthenticationForHostResponse resp = 1;
   */
  resp?: CheckAuthenticationForHostResponse;

  constructor(data?: PartialMessage<CallCheckAuthenticationForHost_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallCheckAuthenticationForHost.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resp", kind: "message", T: CheckAuthenticationForHostResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallCheckAuthenticationForHost_Response {
    return new CallCheckAuthenticationForHost_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallCheckAuthenticationForHost_Response {
    return new CallCheckAuthenticationForHost_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallCheckAuthenticationForHost_Response {
    return new CallCheckAuthenticationForHost_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallCheckAuthenticationForHost_Response | PlainMessage<CallCheckAuthenticationForHost_Response> | undefined, b: CallCheckAuthenticationForHost_Response | PlainMessage<CallCheckAuthenticationForHost_Response> | undefined): boolean {
    return proto3.util.equals(CallCheckAuthenticationForHost_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallCheckRepositoryAccess
 */
export class CallCheckRepositoryAccess extends Message<CallCheckRepositoryAccess> {
  constructor(data?: PartialMessage<CallCheckRepositoryAccess>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallCheckRepositoryAccess";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallCheckRepositoryAccess {
    return new CallCheckRepositoryAccess().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallCheckRepositoryAccess {
    return new CallCheckRepositoryAccess().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallCheckRepositoryAccess {
    return new CallCheckRepositoryAccess().fromJsonString(jsonString, options);
  }

  static equals(a: CallCheckRepositoryAccess | PlainMessage<CallCheckRepositoryAccess> | undefined, b: CallCheckRepositoryAccess | PlainMessage<CallCheckRepositoryAccess> | undefined): boolean {
    return proto3.util.equals(CallCheckRepositoryAccess, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallCheckRepositoryAccess.Request
 */
export class CallCheckRepositoryAccess_Request extends Message<CallCheckRepositoryAccess_Request> {
  /**
   * principal_id is the ID of the user or service account to check access for.
   *
   * @generated from field: string principal_id = 1;
   */
  principalId = "";

  /**
   * repository_url is the URL of the repository to check access for.
   *
   * @generated from field: string repository_url = 2;
   */
  repositoryUrl = "";

  constructor(data?: PartialMessage<CallCheckRepositoryAccess_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallCheckRepositoryAccess.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "repository_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallCheckRepositoryAccess_Request {
    return new CallCheckRepositoryAccess_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallCheckRepositoryAccess_Request {
    return new CallCheckRepositoryAccess_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallCheckRepositoryAccess_Request {
    return new CallCheckRepositoryAccess_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallCheckRepositoryAccess_Request | PlainMessage<CallCheckRepositoryAccess_Request> | undefined, b: CallCheckRepositoryAccess_Request | PlainMessage<CallCheckRepositoryAccess_Request> | undefined): boolean {
    return proto3.util.equals(CallCheckRepositoryAccess_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallCheckRepositoryAccess.Response
 */
export class CallCheckRepositoryAccess_Response extends Message<CallCheckRepositoryAccess_Response> {
  /**
   * @generated from field: gitpod.v1.CheckRepositoryAccessResponse resp = 1;
   */
  resp?: CheckRepositoryAccessResponse;

  constructor(data?: PartialMessage<CallCheckRepositoryAccess_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallCheckRepositoryAccess.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "resp", kind: "message", T: CheckRepositoryAccessResponse },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallCheckRepositoryAccess_Response {
    return new CallCheckRepositoryAccess_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallCheckRepositoryAccess_Response {
    return new CallCheckRepositoryAccess_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallCheckRepositoryAccess_Response {
    return new CallCheckRepositoryAccess_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallCheckRepositoryAccess_Response | PlainMessage<CallCheckRepositoryAccess_Response> | undefined, b: CallCheckRepositoryAccess_Response | PlainMessage<CallCheckRepositoryAccess_Response> | undefined): boolean {
    return proto3.util.equals(CallCheckRepositoryAccess_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallSearchRepositories
 */
export class CallSearchRepositories extends Message<CallSearchRepositories> {
  constructor(data?: PartialMessage<CallSearchRepositories>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallSearchRepositories";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallSearchRepositories {
    return new CallSearchRepositories().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallSearchRepositories {
    return new CallSearchRepositories().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallSearchRepositories {
    return new CallSearchRepositories().fromJsonString(jsonString, options);
  }

  static equals(a: CallSearchRepositories | PlainMessage<CallSearchRepositories> | undefined, b: CallSearchRepositories | PlainMessage<CallSearchRepositories> | undefined): boolean {
    return proto3.util.equals(CallSearchRepositories, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallSearchRepositories.Request
 */
export class CallSearchRepositories_Request extends Message<CallSearchRepositories_Request> {
  /**
   * The principal's ID to search repositories for
   *
   * @generated from field: string principal_id = 1;
   */
  principalId = "";

  /**
   * Search query - interpretation depends on search_mode
   *
   * @generated from field: string search_string = 2;
   */
  searchString = "";

  /**
   * Maximum number of repositories to return.
   * Deprecated: Use pagination.page_size instead
   *
   * @generated from field: int32 limit = 3 [deprecated = true];
   * @deprecated
   */
  limit = 0;

  /**
   * Pagination parameters for repository search
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequest;

  /**
   * The SCM's host to search repositories for
   *
   * @generated from field: string scm_host = 5;
   */
  scmHost = "";

  /**
   * Search mode determines how search_string is interpreted
   *
   * @generated from field: gitpod.v1.SearchMode search_mode = 6;
   */
  searchMode = SearchMode.UNSPECIFIED;

  constructor(data?: PartialMessage<CallSearchRepositories_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallSearchRepositories.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "search_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 5, name: "scm_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "search_mode", kind: "enum", T: proto3.getEnumType(SearchMode) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallSearchRepositories_Request {
    return new CallSearchRepositories_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallSearchRepositories_Request {
    return new CallSearchRepositories_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallSearchRepositories_Request {
    return new CallSearchRepositories_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallSearchRepositories_Request | PlainMessage<CallSearchRepositories_Request> | undefined, b: CallSearchRepositories_Request | PlainMessage<CallSearchRepositories_Request> | undefined): boolean {
    return proto3.util.equals(CallSearchRepositories_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallSearchRepositories.Response
 */
export class CallSearchRepositories_Response extends Message<CallSearchRepositories_Response> {
  /**
   * List of repositories matching the search criteria
   *
   * @generated from field: repeated gitpod.v1.SearchRepositoriesResponse.Repository repositories = 1;
   */
  repositories: SearchRepositoriesResponse_Repository[] = [];

  /**
   * Pagination information for the response.
   * Token format: "NEXT_PAGE/TOTAL_PAGES/TOTAL_COUNT" (e.g., "2/40/1000").
   * Use -1 for unknown values (e.g., "2/-1/-1" when totals unavailable).
   * Empty token means no more pages.
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse;

  /**
   * Deprecated: Use pagination token instead. Total pages can be extracted from token.
   *
   * @generated from field: int32 last_page = 3;
   */
  lastPage = 0;

  constructor(data?: PartialMessage<CallSearchRepositories_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallSearchRepositories.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "repositories", kind: "message", T: SearchRepositoriesResponse_Repository, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 3, name: "last_page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallSearchRepositories_Response {
    return new CallSearchRepositories_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallSearchRepositories_Response {
    return new CallSearchRepositories_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallSearchRepositories_Response {
    return new CallSearchRepositories_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallSearchRepositories_Response | PlainMessage<CallSearchRepositories_Response> | undefined, b: CallSearchRepositories_Response | PlainMessage<CallSearchRepositories_Response> | undefined): boolean {
    return proto3.util.equals(CallSearchRepositories_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallListSCMOrganizations
 */
export class CallListSCMOrganizations extends Message<CallListSCMOrganizations> {
  constructor(data?: PartialMessage<CallListSCMOrganizations>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallListSCMOrganizations";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallListSCMOrganizations {
    return new CallListSCMOrganizations().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallListSCMOrganizations {
    return new CallListSCMOrganizations().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallListSCMOrganizations {
    return new CallListSCMOrganizations().fromJsonString(jsonString, options);
  }

  static equals(a: CallListSCMOrganizations | PlainMessage<CallListSCMOrganizations> | undefined, b: CallListSCMOrganizations | PlainMessage<CallListSCMOrganizations> | undefined): boolean {
    return proto3.util.equals(CallListSCMOrganizations, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallListSCMOrganizations.Request
 */
export class CallListSCMOrganizations_Request extends Message<CallListSCMOrganizations_Request> {
  /**
   * The principal's ID to list organizations for
   *
   * @generated from field: string principal_id = 1;
   */
  principalId = "";

  /**
   * The SCM host to list organizations from (e.g., "github.com", "gitlab.com")
   *
   * @generated from field: string scm_host = 2;
   */
  scmHost = "";

  constructor(data?: PartialMessage<CallListSCMOrganizations_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallListSCMOrganizations.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "principal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "scm_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallListSCMOrganizations_Request {
    return new CallListSCMOrganizations_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallListSCMOrganizations_Request {
    return new CallListSCMOrganizations_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallListSCMOrganizations_Request {
    return new CallListSCMOrganizations_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallListSCMOrganizations_Request | PlainMessage<CallListSCMOrganizations_Request> | undefined, b: CallListSCMOrganizations_Request | PlainMessage<CallListSCMOrganizations_Request> | undefined): boolean {
    return proto3.util.equals(CallListSCMOrganizations_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallListSCMOrganizations.Response
 */
export class CallListSCMOrganizations_Response extends Message<CallListSCMOrganizations_Response> {
  /**
   * List of organizations the user belongs to
   *
   * @generated from field: repeated gitpod.v1.ListSCMOrganizationsResponse.SCMOrganization organizations = 1;
   */
  organizations: ListSCMOrganizationsResponse_SCMOrganization[] = [];

  constructor(data?: PartialMessage<CallListSCMOrganizations_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallListSCMOrganizations.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organizations", kind: "message", T: ListSCMOrganizationsResponse_SCMOrganization, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallListSCMOrganizations_Response {
    return new CallListSCMOrganizations_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallListSCMOrganizations_Response {
    return new CallListSCMOrganizations_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallListSCMOrganizations_Response {
    return new CallListSCMOrganizations_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallListSCMOrganizations_Response | PlainMessage<CallListSCMOrganizations_Response> | undefined, b: CallListSCMOrganizations_Response | PlainMessage<CallListSCMOrganizations_Response> | undefined): boolean {
    return proto3.util.equals(CallListSCMOrganizations_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallValidateConfig
 */
export class CallValidateConfig extends Message<CallValidateConfig> {
  constructor(data?: PartialMessage<CallValidateConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallValidateConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallValidateConfig {
    return new CallValidateConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallValidateConfig {
    return new CallValidateConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallValidateConfig {
    return new CallValidateConfig().fromJsonString(jsonString, options);
  }

  static equals(a: CallValidateConfig | PlainMessage<CallValidateConfig> | undefined, b: CallValidateConfig | PlainMessage<CallValidateConfig> | undefined): boolean {
    return proto3.util.equals(CallValidateConfig, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallValidateConfig.Request
 */
export class CallValidateConfig_Request extends Message<CallValidateConfig_Request> {
  /**
   * @generated from oneof gitpod.v1.CallValidateConfig.Request.config
   */
  config: {
    /**
     * @generated from field: gitpod.v1.EnvironmentClass environment_class = 1;
     */
    value: EnvironmentClass;
    case: "environmentClass";
  } | {
    /**
     * @generated from field: gitpod.v1.SCMIntegration scm = 2;
     */
    value: SCMIntegration;
    case: "scm";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CallValidateConfig_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallValidateConfig.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_class", kind: "message", T: EnvironmentClass, oneof: "config" },
    { no: 2, name: "scm", kind: "message", T: SCMIntegration, oneof: "config" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallValidateConfig_Request {
    return new CallValidateConfig_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallValidateConfig_Request {
    return new CallValidateConfig_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallValidateConfig_Request {
    return new CallValidateConfig_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallValidateConfig_Request | PlainMessage<CallValidateConfig_Request> | undefined, b: CallValidateConfig_Request | PlainMessage<CallValidateConfig_Request> | undefined): boolean {
    return proto3.util.equals(CallValidateConfig_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallValidateConfig.Response
 */
export class CallValidateConfig_Response extends Message<CallValidateConfig_Response> {
  /**
   * @generated from oneof gitpod.v1.CallValidateConfig.Response.result
   */
  result: {
    /**
     * @generated from field: gitpod.v1.EnvironmentClassValidationResult environment_class = 1;
     */
    value: EnvironmentClassValidationResult;
    case: "environmentClass";
  } | {
    /**
     * @generated from field: gitpod.v1.SCMIntegrationValidationResult scm = 2;
     */
    value: SCMIntegrationValidationResult;
    case: "scm";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CallValidateConfig_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallValidateConfig.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "environment_class", kind: "message", T: EnvironmentClassValidationResult, oneof: "result" },
    { no: 2, name: "scm", kind: "message", T: SCMIntegrationValidationResult, oneof: "result" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallValidateConfig_Response {
    return new CallValidateConfig_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallValidateConfig_Response {
    return new CallValidateConfig_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallValidateConfig_Response {
    return new CallValidateConfig_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallValidateConfig_Response | PlainMessage<CallValidateConfig_Response> | undefined, b: CallValidateConfig_Response | PlainMessage<CallValidateConfig_Response> | undefined): boolean {
    return proto3.util.equals(CallValidateConfig_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallSendMessageToAgentExecution
 */
export class CallSendMessageToAgentExecution extends Message<CallSendMessageToAgentExecution> {
  constructor(data?: PartialMessage<CallSendMessageToAgentExecution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallSendMessageToAgentExecution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallSendMessageToAgentExecution {
    return new CallSendMessageToAgentExecution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallSendMessageToAgentExecution {
    return new CallSendMessageToAgentExecution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallSendMessageToAgentExecution {
    return new CallSendMessageToAgentExecution().fromJsonString(jsonString, options);
  }

  static equals(a: CallSendMessageToAgentExecution | PlainMessage<CallSendMessageToAgentExecution> | undefined, b: CallSendMessageToAgentExecution | PlainMessage<CallSendMessageToAgentExecution> | undefined): boolean {
    return proto3.util.equals(CallSendMessageToAgentExecution, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallSendMessageToAgentExecution.Request
 */
export class CallSendMessageToAgentExecution_Request extends Message<CallSendMessageToAgentExecution_Request> {
  /**
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId = "";

  /**
   * @generated from field: gitpod.v1.UserInputBlock message = 2;
   */
  message?: UserInputBlock;

  constructor(data?: PartialMessage<CallSendMessageToAgentExecution_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallSendMessageToAgentExecution.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "message", T: UserInputBlock },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallSendMessageToAgentExecution_Request {
    return new CallSendMessageToAgentExecution_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallSendMessageToAgentExecution_Request {
    return new CallSendMessageToAgentExecution_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallSendMessageToAgentExecution_Request {
    return new CallSendMessageToAgentExecution_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallSendMessageToAgentExecution_Request | PlainMessage<CallSendMessageToAgentExecution_Request> | undefined, b: CallSendMessageToAgentExecution_Request | PlainMessage<CallSendMessageToAgentExecution_Request> | undefined): boolean {
    return proto3.util.equals(CallSendMessageToAgentExecution_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallSendMessageToAgentExecution.Response
 */
export class CallSendMessageToAgentExecution_Response extends Message<CallSendMessageToAgentExecution_Response> {
  constructor(data?: PartialMessage<CallSendMessageToAgentExecution_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallSendMessageToAgentExecution.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallSendMessageToAgentExecution_Response {
    return new CallSendMessageToAgentExecution_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallSendMessageToAgentExecution_Response {
    return new CallSendMessageToAgentExecution_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallSendMessageToAgentExecution_Response {
    return new CallSendMessageToAgentExecution_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallSendMessageToAgentExecution_Response | PlainMessage<CallSendMessageToAgentExecution_Response> | undefined, b: CallSendMessageToAgentExecution_Response | PlainMessage<CallSendMessageToAgentExecution_Response> | undefined): boolean {
    return proto3.util.equals(CallSendMessageToAgentExecution_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallImprovePromptForAgent
 */
export class CallImprovePromptForAgent extends Message<CallImprovePromptForAgent> {
  constructor(data?: PartialMessage<CallImprovePromptForAgent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallImprovePromptForAgent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallImprovePromptForAgent {
    return new CallImprovePromptForAgent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallImprovePromptForAgent {
    return new CallImprovePromptForAgent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallImprovePromptForAgent {
    return new CallImprovePromptForAgent().fromJsonString(jsonString, options);
  }

  static equals(a: CallImprovePromptForAgent | PlainMessage<CallImprovePromptForAgent> | undefined, b: CallImprovePromptForAgent | PlainMessage<CallImprovePromptForAgent> | undefined): boolean {
    return proto3.util.equals(CallImprovePromptForAgent, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallImprovePromptForAgent.Request
 */
export class CallImprovePromptForAgent_Request extends Message<CallImprovePromptForAgent_Request> {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId = "";

  /**
   * @generated from field: string prompt = 2;
   */
  prompt = "";

  constructor(data?: PartialMessage<CallImprovePromptForAgent_Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallImprovePromptForAgent.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallImprovePromptForAgent_Request {
    return new CallImprovePromptForAgent_Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallImprovePromptForAgent_Request {
    return new CallImprovePromptForAgent_Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallImprovePromptForAgent_Request {
    return new CallImprovePromptForAgent_Request().fromJsonString(jsonString, options);
  }

  static equals(a: CallImprovePromptForAgent_Request | PlainMessage<CallImprovePromptForAgent_Request> | undefined, b: CallImprovePromptForAgent_Request | PlainMessage<CallImprovePromptForAgent_Request> | undefined): boolean {
    return proto3.util.equals(CallImprovePromptForAgent_Request, a, b);
  }
}

/**
 * @generated from message gitpod.v1.CallImprovePromptForAgent.Response
 */
export class CallImprovePromptForAgent_Response extends Message<CallImprovePromptForAgent_Response> {
  /**
   * @generated from field: string improved_prompt = 1;
   */
  improvedPrompt = "";

  constructor(data?: PartialMessage<CallImprovePromptForAgent_Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.CallImprovePromptForAgent.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "improved_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CallImprovePromptForAgent_Response {
    return new CallImprovePromptForAgent_Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CallImprovePromptForAgent_Response {
    return new CallImprovePromptForAgent_Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CallImprovePromptForAgent_Response {
    return new CallImprovePromptForAgent_Response().fromJsonString(jsonString, options);
  }

  static equals(a: CallImprovePromptForAgent_Response | PlainMessage<CallImprovePromptForAgent_Response> | undefined, b: CallImprovePromptForAgent_Response | PlainMessage<CallImprovePromptForAgent_Response> | undefined): boolean {
    return proto3.util.equals(CallImprovePromptForAgent_Response, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetLatestVersionRequest
 */
export class GetLatestVersionRequest extends Message<GetLatestVersionRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The current version of the runner
   *
   * @generated from field: string current_version = 2;
   */
  currentVersion = "";

  /**
   * The version of the infrastructure
   *
   * @generated from field: string infrastructure_version = 3;
   */
  infrastructureVersion = "";

  constructor(data?: PartialMessage<GetLatestVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetLatestVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "current_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "infrastructure_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLatestVersionRequest {
    return new GetLatestVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLatestVersionRequest {
    return new GetLatestVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLatestVersionRequest {
    return new GetLatestVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLatestVersionRequest | PlainMessage<GetLatestVersionRequest> | undefined, b: GetLatestVersionRequest | PlainMessage<GetLatestVersionRequest> | undefined): boolean {
    return proto3.util.equals(GetLatestVersionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetLatestVersionResponse
 */
export class GetLatestVersionResponse extends Message<GetLatestVersionResponse> {
  /**
   * The latest version of the runner
   *
   * @generated from field: string version = 1;
   */
  version = "";

  /**
   * deprecated: aws-specific field, use manifest.aws_ec2.runner_image instead
   *
   * @generated from field: string runner_image = 2;
   */
  runnerImage = "";

  /**
   * auto-update indicates if the runner should be updated automatically
   *
   * @generated from field: bool auto_update = 3;
   */
  autoUpdate = false;

  /**
   * supervisor_download_url is the URL to download the supervisor
   *
   * @generated from field: string supervisor_download_url = 4;
   */
  supervisorDownloadUrl = "";

  /**
   * gitpod_cli_download_url is the URL to download the gitpod CLI
   *
   * @generated from field: string gitpod_cli_download_url = 5;
   */
  gitpodCliDownloadUrl = "";

  /**
   * one of based on runner provider
   *
   * @generated from oneof gitpod.v1.GetLatestVersionResponse.manifest
   */
  manifest: {
    /**
     * @generated from field: gitpod.v1.GetLatestVersionResponse.AwsEc2Manifest aws_ec2 = 10;
     */
    value: GetLatestVersionResponse_AwsEc2Manifest;
    case: "awsEc2";
  } | {
    /**
     * @generated from field: gitpod.v1.GetLatestVersionResponse.LinuxHostManifest linux_host = 20;
     */
    value: GetLatestVersionResponse_LinuxHostManifest;
    case: "linuxHost";
  } | {
    /**
     * @generated from field: gitpod.v1.GetLatestVersionResponse.GcpManifest gcp = 30;
     */
    value: GetLatestVersionResponse_GcpManifest;
    case: "gcp";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<GetLatestVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetLatestVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "runner_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "auto_update", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "supervisor_download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "gitpod_cli_download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "aws_ec2", kind: "message", T: GetLatestVersionResponse_AwsEc2Manifest, oneof: "manifest" },
    { no: 20, name: "linux_host", kind: "message", T: GetLatestVersionResponse_LinuxHostManifest, oneof: "manifest" },
    { no: 30, name: "gcp", kind: "message", T: GetLatestVersionResponse_GcpManifest, oneof: "manifest" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLatestVersionResponse {
    return new GetLatestVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLatestVersionResponse {
    return new GetLatestVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLatestVersionResponse {
    return new GetLatestVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLatestVersionResponse | PlainMessage<GetLatestVersionResponse> | undefined, b: GetLatestVersionResponse | PlainMessage<GetLatestVersionResponse> | undefined): boolean {
    return proto3.util.equals(GetLatestVersionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetLatestVersionResponse.AwsEc2Manifest
 */
export class GetLatestVersionResponse_AwsEc2Manifest extends Message<GetLatestVersionResponse_AwsEc2Manifest> {
  /**
   * The container image of the runner.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   *
   * @generated from field: string runner_image = 1;
   */
  runnerImage = "";

  /**
   * The container image of the proxy.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   *
   * @generated from field: string proxy_image = 2;
   */
  proxyImage = "";

  /**
   * Map of AWS region to AMI image ID for the ECS host instances.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   * Key is AWS region (e.g., "us-east-1"), value is AMI ID (e.g., "ami-12345678").
   *
   * @generated from field: map<string, string> ami_image_map = 3;
   */
  amiImageMap: { [key: string]: string } = {};

  constructor(data?: PartialMessage<GetLatestVersionResponse_AwsEc2Manifest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetLatestVersionResponse.AwsEc2Manifest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "proxy_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ami_image_map", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLatestVersionResponse_AwsEc2Manifest {
    return new GetLatestVersionResponse_AwsEc2Manifest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLatestVersionResponse_AwsEc2Manifest {
    return new GetLatestVersionResponse_AwsEc2Manifest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLatestVersionResponse_AwsEc2Manifest {
    return new GetLatestVersionResponse_AwsEc2Manifest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLatestVersionResponse_AwsEc2Manifest | PlainMessage<GetLatestVersionResponse_AwsEc2Manifest> | undefined, b: GetLatestVersionResponse_AwsEc2Manifest | PlainMessage<GetLatestVersionResponse_AwsEc2Manifest> | undefined): boolean {
    return proto3.util.equals(GetLatestVersionResponse_AwsEc2Manifest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetLatestVersionResponse.LinuxHostManifest
 */
export class GetLatestVersionResponse_LinuxHostManifest extends Message<GetLatestVersionResponse_LinuxHostManifest> {
  /**
   * @generated from field: string linux_runner_url = 1;
   */
  linuxRunnerUrl = "";

  /**
   * @generated from field: string kernel_image_url = 2;
   */
  kernelImageUrl = "";

  /**
   * @generated from field: string rootfs_disk_image_url = 3;
   */
  rootfsDiskImageUrl = "";

  /**
   * @generated from field: string shared_disk_image_url = 4;
   */
  sharedDiskImageUrl = "";

  /**
   * @generated from field: string cloud_hypervisor_url = 5;
   */
  cloudHypervisorUrl = "";

  /**
   * @generated from field: string ch_remote_static_url = 6;
   */
  chRemoteStaticUrl = "";

  /**
   * @generated from field: string zstd_url = 7;
   */
  zstdUrl = "";

  constructor(data?: PartialMessage<GetLatestVersionResponse_LinuxHostManifest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetLatestVersionResponse.LinuxHostManifest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "linux_runner_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kernel_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "rootfs_disk_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "shared_disk_image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "cloud_hypervisor_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ch_remote_static_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "zstd_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLatestVersionResponse_LinuxHostManifest {
    return new GetLatestVersionResponse_LinuxHostManifest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLatestVersionResponse_LinuxHostManifest {
    return new GetLatestVersionResponse_LinuxHostManifest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLatestVersionResponse_LinuxHostManifest {
    return new GetLatestVersionResponse_LinuxHostManifest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLatestVersionResponse_LinuxHostManifest | PlainMessage<GetLatestVersionResponse_LinuxHostManifest> | undefined, b: GetLatestVersionResponse_LinuxHostManifest | PlainMessage<GetLatestVersionResponse_LinuxHostManifest> | undefined): boolean {
    return proto3.util.equals(GetLatestVersionResponse_LinuxHostManifest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetLatestVersionResponse.GcpManifest
 */
export class GetLatestVersionResponse_GcpManifest extends Message<GetLatestVersionResponse_GcpManifest> {
  /**
   * The container image of the runner.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   *
   * @generated from field: string runner_image = 1;
   */
  runnerImage = "";

  /**
   * The container image of the proxy.
   * Will only be set if the latest release in the release channel has the same infrastructure version as the runner.
   *
   * @generated from field: string proxy_image = 2;
   */
  proxyImage = "";

  /**
   * Terraform files to be used to create the runner.
   *
   * @generated from field: repeated string terraform_files = 3;
   */
  terraformFiles: string[] = [];

  /**
   * Download URL for the terraform files.
   *
   * @generated from field: string download_url = 4;
   */
  downloadUrl = "";

  constructor(data?: PartialMessage<GetLatestVersionResponse_GcpManifest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetLatestVersionResponse.GcpManifest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "proxy_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "terraform_files", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLatestVersionResponse_GcpManifest {
    return new GetLatestVersionResponse_GcpManifest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLatestVersionResponse_GcpManifest {
    return new GetLatestVersionResponse_GcpManifest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLatestVersionResponse_GcpManifest {
    return new GetLatestVersionResponse_GcpManifest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLatestVersionResponse_GcpManifest | PlainMessage<GetLatestVersionResponse_GcpManifest> | undefined, b: GetLatestVersionResponse_GcpManifest | PlainMessage<GetLatestVersionResponse_GcpManifest> | undefined): boolean {
    return proto3.util.equals(GetLatestVersionResponse_GcpManifest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerConfigurationRequest
 */
export class GetRunnerConfigurationRequest extends Message<GetRunnerConfigurationRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  constructor(data?: PartialMessage<GetRunnerConfigurationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerConfigurationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerConfigurationRequest {
    return new GetRunnerConfigurationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerConfigurationRequest {
    return new GetRunnerConfigurationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerConfigurationRequest {
    return new GetRunnerConfigurationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerConfigurationRequest | PlainMessage<GetRunnerConfigurationRequest> | undefined, b: GetRunnerConfigurationRequest | PlainMessage<GetRunnerConfigurationRequest> | undefined): boolean {
    return proto3.util.equals(GetRunnerConfigurationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerMetricsConfiguration
 */
export class RunnerMetricsConfiguration extends Message<RunnerMetricsConfiguration> {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  /**
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * @generated from field: bytes encrypted_username = 3;
   */
  encryptedUsername = new Uint8Array(0);

  /**
   * @generated from field: bytes encrypted_password = 4;
   */
  encryptedPassword = new Uint8Array(0);

  constructor(data?: PartialMessage<RunnerMetricsConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerMetricsConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "encrypted_username", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "encrypted_password", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerMetricsConfiguration {
    return new RunnerMetricsConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerMetricsConfiguration {
    return new RunnerMetricsConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerMetricsConfiguration {
    return new RunnerMetricsConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerMetricsConfiguration | PlainMessage<RunnerMetricsConfiguration> | undefined, b: RunnerMetricsConfiguration | PlainMessage<RunnerMetricsConfiguration> | undefined): boolean {
    return proto3.util.equals(RunnerMetricsConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerConfigurationResponse
 */
export class GetRunnerConfigurationResponse extends Message<GetRunnerConfigurationResponse> {
  /**
   * @generated from field: gitpod.v1.GetRunnerConfigurationResponse.RunnerConfiguration configuration = 1;
   */
  configuration?: GetRunnerConfigurationResponse_RunnerConfiguration;

  constructor(data?: PartialMessage<GetRunnerConfigurationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerConfigurationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "configuration", kind: "message", T: GetRunnerConfigurationResponse_RunnerConfiguration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerConfigurationResponse {
    return new GetRunnerConfigurationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerConfigurationResponse {
    return new GetRunnerConfigurationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerConfigurationResponse {
    return new GetRunnerConfigurationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerConfigurationResponse | PlainMessage<GetRunnerConfigurationResponse> | undefined, b: GetRunnerConfigurationResponse | PlainMessage<GetRunnerConfigurationResponse> | undefined): boolean {
    return proto3.util.equals(GetRunnerConfigurationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerConfigurationResponse.RunnerConfiguration
 */
export class GetRunnerConfigurationResponse_RunnerConfiguration extends Message<GetRunnerConfigurationResponse_RunnerConfiguration> {
  /**
   * @generated from field: string region = 1;
   */
  region = "";

  /**
   * @generated from field: gitpod.v1.RunnerReleaseChannel release_channel = 2;
   */
  releaseChannel = RunnerReleaseChannel.UNSPECIFIED;

  /**
   * @generated from field: bool auto_update = 3;
   */
  autoUpdate = false;

  /**
   * @generated from field: gitpod.v1.RunnerMetricsConfiguration metrics = 4;
   */
  metrics?: RunnerMetricsConfiguration;

  /**
   * @generated from field: gitpod.v1.LogLevel log_level = 5;
   */
  logLevel = LogLevel.UNSPECIFIED;

  /**
   * @generated from field: bool devcontainer_image_cache_enabled = 6;
   */
  devcontainerImageCacheEnabled = false;

  constructor(data?: PartialMessage<GetRunnerConfigurationResponse_RunnerConfiguration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerConfigurationResponse.RunnerConfiguration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "release_channel", kind: "enum", T: proto3.getEnumType(RunnerReleaseChannel) },
    { no: 3, name: "auto_update", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "metrics", kind: "message", T: RunnerMetricsConfiguration },
    { no: 5, name: "log_level", kind: "enum", T: proto3.getEnumType(LogLevel) },
    { no: 6, name: "devcontainer_image_cache_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerConfigurationResponse_RunnerConfiguration {
    return new GetRunnerConfigurationResponse_RunnerConfiguration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerConfigurationResponse_RunnerConfiguration {
    return new GetRunnerConfigurationResponse_RunnerConfiguration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerConfigurationResponse_RunnerConfiguration {
    return new GetRunnerConfigurationResponse_RunnerConfiguration().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerConfigurationResponse_RunnerConfiguration | PlainMessage<GetRunnerConfigurationResponse_RunnerConfiguration> | undefined, b: GetRunnerConfigurationResponse_RunnerConfiguration | PlainMessage<GetRunnerConfigurationResponse_RunnerConfiguration> | undefined): boolean {
    return proto3.util.equals(GetRunnerConfigurationResponse_RunnerConfiguration, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerAgentExecutionsRequest
 */
export class ListRunnerAgentExecutionsRequest extends Message<ListRunnerAgentExecutionsRequest> {
  /**
   * pagination contains the pagination options for listing agent executions
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  constructor(data?: PartialMessage<ListRunnerAgentExecutionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerAgentExecutionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerAgentExecutionsRequest {
    return new ListRunnerAgentExecutionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerAgentExecutionsRequest {
    return new ListRunnerAgentExecutionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerAgentExecutionsRequest {
    return new ListRunnerAgentExecutionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerAgentExecutionsRequest | PlainMessage<ListRunnerAgentExecutionsRequest> | undefined, b: ListRunnerAgentExecutionsRequest | PlainMessage<ListRunnerAgentExecutionsRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerAgentExecutionsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerAgentExecution
 */
export class RunnerAgentExecution extends Message<RunnerAgentExecution> {
  /**
   * @generated from field: gitpod.v1.AgentExecution agent_execution = 1;
   */
  agentExecution?: AgentExecution;

  /**
   * @generated from field: string actor_access_token = 3;
   */
  actorAccessToken = "";

  constructor(data?: PartialMessage<RunnerAgentExecution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerAgentExecution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution", kind: "message", T: AgentExecution },
    { no: 3, name: "actor_access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerAgentExecution {
    return new RunnerAgentExecution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerAgentExecution {
    return new RunnerAgentExecution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerAgentExecution {
    return new RunnerAgentExecution().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerAgentExecution | PlainMessage<RunnerAgentExecution> | undefined, b: RunnerAgentExecution | PlainMessage<RunnerAgentExecution> | undefined): boolean {
    return proto3.util.equals(RunnerAgentExecution, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerAgentExecutionsResponse
 */
export class ListRunnerAgentExecutionsResponse extends Message<ListRunnerAgentExecutionsResponse> {
  /**
   * pagination contains the pagination options for listing agent executions
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The agent ListRunnerAgentExecutionsRequest on the runner
   *
   * @generated from field: repeated gitpod.v1.RunnerAgentExecution agent_executions = 2;
   */
  agentExecutions: RunnerAgentExecution[] = [];

  constructor(data?: PartialMessage<ListRunnerAgentExecutionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerAgentExecutionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "agent_executions", kind: "message", T: RunnerAgentExecution, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerAgentExecutionsResponse {
    return new ListRunnerAgentExecutionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerAgentExecutionsResponse {
    return new ListRunnerAgentExecutionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerAgentExecutionsResponse {
    return new ListRunnerAgentExecutionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerAgentExecutionsResponse | PlainMessage<ListRunnerAgentExecutionsResponse> | undefined, b: ListRunnerAgentExecutionsResponse | PlainMessage<ListRunnerAgentExecutionsResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerAgentExecutionsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerAgentExecutionRequest
 */
export class GetRunnerAgentExecutionRequest extends Message<GetRunnerAgentExecutionRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * @generated from field: string agent_execution_id = 2;
   */
  agentExecutionId = "";

  constructor(data?: PartialMessage<GetRunnerAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerAgentExecutionRequest {
    return new GetRunnerAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerAgentExecutionRequest {
    return new GetRunnerAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerAgentExecutionRequest {
    return new GetRunnerAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerAgentExecutionRequest | PlainMessage<GetRunnerAgentExecutionRequest> | undefined, b: GetRunnerAgentExecutionRequest | PlainMessage<GetRunnerAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(GetRunnerAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerAgentExecutionResponse
 */
export class GetRunnerAgentExecutionResponse extends Message<GetRunnerAgentExecutionResponse> {
  /**
   * @generated from field: gitpod.v1.RunnerAgentExecution agent_execution = 1;
   */
  agentExecution?: RunnerAgentExecution;

  constructor(data?: PartialMessage<GetRunnerAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agent_execution", kind: "message", T: RunnerAgentExecution },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerAgentExecutionResponse {
    return new GetRunnerAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerAgentExecutionResponse {
    return new GetRunnerAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerAgentExecutionResponse {
    return new GetRunnerAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerAgentExecutionResponse | PlainMessage<GetRunnerAgentExecutionResponse> | undefined, b: GetRunnerAgentExecutionResponse | PlainMessage<GetRunnerAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(GetRunnerAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerAgentExecutionRequest
 */
export class UpdateRunnerAgentExecutionRequest extends Message<UpdateRunnerAgentExecutionRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * @generated from field: string agent_execution_id = 2;
   */
  agentExecutionId = "";

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: gitpod.v1.AgentExecution.Status status = 5;
   */
  status?: AgentExecution_Status;

  constructor(data?: PartialMessage<UpdateRunnerAgentExecutionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerAgentExecutionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "status", kind: "message", T: AgentExecution_Status },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerAgentExecutionRequest {
    return new UpdateRunnerAgentExecutionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerAgentExecutionRequest {
    return new UpdateRunnerAgentExecutionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerAgentExecutionRequest {
    return new UpdateRunnerAgentExecutionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerAgentExecutionRequest | PlainMessage<UpdateRunnerAgentExecutionRequest> | undefined, b: UpdateRunnerAgentExecutionRequest | PlainMessage<UpdateRunnerAgentExecutionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerAgentExecutionRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerAgentExecutionResponse
 */
export class UpdateRunnerAgentExecutionResponse extends Message<UpdateRunnerAgentExecutionResponse> {
  constructor(data?: PartialMessage<UpdateRunnerAgentExecutionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerAgentExecutionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerAgentExecutionResponse {
    return new UpdateRunnerAgentExecutionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerAgentExecutionResponse {
    return new UpdateRunnerAgentExecutionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerAgentExecutionResponse {
    return new UpdateRunnerAgentExecutionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerAgentExecutionResponse | PlainMessage<UpdateRunnerAgentExecutionResponse> | undefined, b: UpdateRunnerAgentExecutionResponse | PlainMessage<UpdateRunnerAgentExecutionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerAgentExecutionResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerLLMIntegrationRequest
 */
export class GetRunnerLLMIntegrationRequest extends Message<GetRunnerLLMIntegrationRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The LLM integration's ID
   *
   * @generated from field: string llm_integration_id = 2;
   */
  llmIntegrationId = "";

  constructor(data?: PartialMessage<GetRunnerLLMIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerLLMIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "llm_integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerLLMIntegrationRequest {
    return new GetRunnerLLMIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerLLMIntegrationRequest {
    return new GetRunnerLLMIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerLLMIntegrationRequest {
    return new GetRunnerLLMIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerLLMIntegrationRequest | PlainMessage<GetRunnerLLMIntegrationRequest> | undefined, b: GetRunnerLLMIntegrationRequest | PlainMessage<GetRunnerLLMIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(GetRunnerLLMIntegrationRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerLLMIntegrationResponse
 */
export class GetRunnerLLMIntegrationResponse extends Message<GetRunnerLLMIntegrationResponse> {
  /**
   * @generated from field: gitpod.v1.LLMIntegration llm_integration = 1;
   */
  llmIntegration?: LLMIntegration;

  constructor(data?: PartialMessage<GetRunnerLLMIntegrationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerLLMIntegrationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "llm_integration", kind: "message", T: LLMIntegration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerLLMIntegrationResponse {
    return new GetRunnerLLMIntegrationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerLLMIntegrationResponse {
    return new GetRunnerLLMIntegrationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerLLMIntegrationResponse {
    return new GetRunnerLLMIntegrationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerLLMIntegrationResponse | PlainMessage<GetRunnerLLMIntegrationResponse> | undefined, b: GetRunnerLLMIntegrationResponse | PlainMessage<GetRunnerLLMIntegrationResponse> | undefined): boolean {
    return proto3.util.equals(GetRunnerLLMIntegrationResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerLLMIntegrationsRequest
 */
export class ListRunnerLLMIntegrationsRequest extends Message<ListRunnerLLMIntegrationsRequest> {
  /**
   * pagination contains the pagination options for listing LLM integrations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  /**
   * @generated from field: gitpod.v1.ListRunnerLLMIntegrationsRequest.Filter filter = 3;
   */
  filter?: ListRunnerLLMIntegrationsRequest_Filter;

  constructor(data?: PartialMessage<ListRunnerLLMIntegrationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerLLMIntegrationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "message", T: ListRunnerLLMIntegrationsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerLLMIntegrationsRequest {
    return new ListRunnerLLMIntegrationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerLLMIntegrationsRequest {
    return new ListRunnerLLMIntegrationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerLLMIntegrationsRequest {
    return new ListRunnerLLMIntegrationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerLLMIntegrationsRequest | PlainMessage<ListRunnerLLMIntegrationsRequest> | undefined, b: ListRunnerLLMIntegrationsRequest | PlainMessage<ListRunnerLLMIntegrationsRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerLLMIntegrationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerLLMIntegrationsRequest.Filter
 */
export class ListRunnerLLMIntegrationsRequest_Filter extends Message<ListRunnerLLMIntegrationsRequest_Filter> {
  /**
   * supported_models filters the response to only LLM integrations with these models
   *
   * @generated from field: repeated gitpod.v1.SupportedModel supported_models = 1;
   */
  supportedModels: SupportedModel[] = [];

  constructor(data?: PartialMessage<ListRunnerLLMIntegrationsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerLLMIntegrationsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supported_models", kind: "enum", T: proto3.getEnumType(SupportedModel), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerLLMIntegrationsRequest_Filter {
    return new ListRunnerLLMIntegrationsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerLLMIntegrationsRequest_Filter {
    return new ListRunnerLLMIntegrationsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerLLMIntegrationsRequest_Filter {
    return new ListRunnerLLMIntegrationsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerLLMIntegrationsRequest_Filter | PlainMessage<ListRunnerLLMIntegrationsRequest_Filter> | undefined, b: ListRunnerLLMIntegrationsRequest_Filter | PlainMessage<ListRunnerLLMIntegrationsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListRunnerLLMIntegrationsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerLLMIntegrationsResponse
 */
export class ListRunnerLLMIntegrationsResponse extends Message<ListRunnerLLMIntegrationsResponse> {
  /**
   * pagination contains the pagination options for listing LLM integrations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The LLM integrations configured for the runner
   *
   * @generated from field: repeated gitpod.v1.LLMIntegration llm_integrations = 2;
   */
  llmIntegrations: LLMIntegration[] = [];

  constructor(data?: PartialMessage<ListRunnerLLMIntegrationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerLLMIntegrationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "llm_integrations", kind: "message", T: LLMIntegration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerLLMIntegrationsResponse {
    return new ListRunnerLLMIntegrationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerLLMIntegrationsResponse {
    return new ListRunnerLLMIntegrationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerLLMIntegrationsResponse {
    return new ListRunnerLLMIntegrationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerLLMIntegrationsResponse | PlainMessage<ListRunnerLLMIntegrationsResponse> | undefined, b: ListRunnerLLMIntegrationsResponse | PlainMessage<ListRunnerLLMIntegrationsResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerLLMIntegrationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerIntegrationsRequest
 */
export class ListRunnerIntegrationsRequest extends Message<ListRunnerIntegrationsRequest> {
  /**
   * pagination contains the pagination options for listing integrations
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  /**
   * @generated from field: gitpod.v1.ListRunnerIntegrationsRequest.Filter filter = 3;
   */
  filter?: ListRunnerIntegrationsRequest_Filter;

  constructor(data?: PartialMessage<ListRunnerIntegrationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerIntegrationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "message", T: ListRunnerIntegrationsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerIntegrationsRequest {
    return new ListRunnerIntegrationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerIntegrationsRequest {
    return new ListRunnerIntegrationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerIntegrationsRequest {
    return new ListRunnerIntegrationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerIntegrationsRequest | PlainMessage<ListRunnerIntegrationsRequest> | undefined, b: ListRunnerIntegrationsRequest | PlainMessage<ListRunnerIntegrationsRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerIntegrationsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerIntegrationsRequest.Filter
 */
export class ListRunnerIntegrationsRequest_Filter extends Message<ListRunnerIntegrationsRequest_Filter> {
  /**
   * integration_ids filters the response to only integrations with these IDs
   *
   * @generated from field: repeated string integration_ids = 1;
   */
  integrationIds: string[] = [];

  constructor(data?: PartialMessage<ListRunnerIntegrationsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerIntegrationsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerIntegrationsRequest_Filter {
    return new ListRunnerIntegrationsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerIntegrationsRequest_Filter {
    return new ListRunnerIntegrationsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerIntegrationsRequest_Filter {
    return new ListRunnerIntegrationsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerIntegrationsRequest_Filter | PlainMessage<ListRunnerIntegrationsRequest_Filter> | undefined, b: ListRunnerIntegrationsRequest_Filter | PlainMessage<ListRunnerIntegrationsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListRunnerIntegrationsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerIntegrationsResponse
 */
export class ListRunnerIntegrationsResponse extends Message<ListRunnerIntegrationsResponse> {
  /**
   * pagination contains the pagination options for listing integrations
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The integrations configured for the runner
   *
   * @generated from field: repeated gitpod.v1.Integration integrations = 2;
   */
  integrations: Integration[] = [];

  constructor(data?: PartialMessage<ListRunnerIntegrationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerIntegrationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "integrations", kind: "message", T: Integration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerIntegrationsResponse {
    return new ListRunnerIntegrationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerIntegrationsResponse {
    return new ListRunnerIntegrationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerIntegrationsResponse {
    return new ListRunnerIntegrationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerIntegrationsResponse | PlainMessage<ListRunnerIntegrationsResponse> | undefined, b: ListRunnerIntegrationsResponse | PlainMessage<ListRunnerIntegrationsResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerIntegrationsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListManagedRunnersRequest
 */
export class ListManagedRunnersRequest extends Message<ListManagedRunnersRequest> {
  /**
   * pagination contains the pagination options for listing managed runners
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1 [deprecated = true];
   * @deprecated
   */
  pagination?: PaginationRequest;

  /**
   * pagination contains the pagination options for listing managed runners (allowing up to 10000 per page)
   *
   * @generated from field: gitpod.v1.BigPaginationRequest big_pagination = 2;
   */
  bigPagination?: BigPaginationRequest;

  constructor(data?: PartialMessage<ListManagedRunnersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListManagedRunnersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "big_pagination", kind: "message", T: BigPaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListManagedRunnersRequest {
    return new ListManagedRunnersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListManagedRunnersRequest {
    return new ListManagedRunnersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListManagedRunnersRequest {
    return new ListManagedRunnersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListManagedRunnersRequest | PlainMessage<ListManagedRunnersRequest> | undefined, b: ListManagedRunnersRequest | PlainMessage<ListManagedRunnersRequest> | undefined): boolean {
    return proto3.util.equals(ListManagedRunnersRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListManagedRunnersResponse
 */
export class ListManagedRunnersResponse extends Message<ListManagedRunnersResponse> {
  /**
   * pagination contains the pagination options for listing managed runners
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The managed runners
   *
   * @generated from field: repeated gitpod.v1.ManagedRunner runners = 2;
   */
  runners: ManagedRunner[] = [];

  constructor(data?: PartialMessage<ListManagedRunnersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListManagedRunnersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "runners", kind: "message", T: ManagedRunner, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListManagedRunnersResponse {
    return new ListManagedRunnersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListManagedRunnersResponse {
    return new ListManagedRunnersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListManagedRunnersResponse {
    return new ListManagedRunnersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListManagedRunnersResponse | PlainMessage<ListManagedRunnersResponse> | undefined, b: ListManagedRunnersResponse | PlainMessage<ListManagedRunnersResponse> | undefined): boolean {
    return proto3.util.equals(ListManagedRunnersResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetManagedRunnerRequest
 */
export class GetManagedRunnerRequest extends Message<GetManagedRunnerRequest> {
  /**
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  constructor(data?: PartialMessage<GetManagedRunnerRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetManagedRunnerRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetManagedRunnerRequest {
    return new GetManagedRunnerRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetManagedRunnerRequest {
    return new GetManagedRunnerRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetManagedRunnerRequest {
    return new GetManagedRunnerRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetManagedRunnerRequest | PlainMessage<GetManagedRunnerRequest> | undefined, b: GetManagedRunnerRequest | PlainMessage<GetManagedRunnerRequest> | undefined): boolean {
    return proto3.util.equals(GetManagedRunnerRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetManagedRunnerResponse
 */
export class GetManagedRunnerResponse extends Message<GetManagedRunnerResponse> {
  /**
   * @generated from field: gitpod.v1.ManagedRunner runner = 1;
   */
  runner?: ManagedRunner;

  constructor(data?: PartialMessage<GetManagedRunnerResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetManagedRunnerResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner", kind: "message", T: ManagedRunner },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetManagedRunnerResponse {
    return new GetManagedRunnerResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetManagedRunnerResponse {
    return new GetManagedRunnerResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetManagedRunnerResponse {
    return new GetManagedRunnerResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetManagedRunnerResponse | PlainMessage<GetManagedRunnerResponse> | undefined, b: GetManagedRunnerResponse | PlainMessage<GetManagedRunnerResponse> | undefined): boolean {
    return proto3.util.equals(GetManagedRunnerResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ManagedRunner
 */
export class ManagedRunner extends Message<ManagedRunner> {
  /**
   * The runner's ID
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The organization's ID that this runner is assigned to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId = "";

  constructor(data?: PartialMessage<ManagedRunner>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ManagedRunner";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ManagedRunner {
    return new ManagedRunner().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ManagedRunner {
    return new ManagedRunner().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ManagedRunner {
    return new ManagedRunner().fromJsonString(jsonString, options);
  }

  static equals(a: ManagedRunner | PlainMessage<ManagedRunner> | undefined, b: ManagedRunner | PlainMessage<ManagedRunner> | undefined): boolean {
    return proto3.util.equals(ManagedRunner, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WatchManagedRunnersRequest
 */
export class WatchManagedRunnersRequest extends Message<WatchManagedRunnersRequest> {
  constructor(data?: PartialMessage<WatchManagedRunnersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WatchManagedRunnersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WatchManagedRunnersRequest {
    return new WatchManagedRunnersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WatchManagedRunnersRequest {
    return new WatchManagedRunnersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WatchManagedRunnersRequest {
    return new WatchManagedRunnersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: WatchManagedRunnersRequest | PlainMessage<WatchManagedRunnersRequest> | undefined, b: WatchManagedRunnersRequest | PlainMessage<WatchManagedRunnersRequest> | undefined): boolean {
    return proto3.util.equals(WatchManagedRunnersRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.WatchManagedRunnersResponse
 */
export class WatchManagedRunnersResponse extends Message<WatchManagedRunnersResponse> {
  /**
   * The runner's ID
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * The type of event that occurred
   *
   * @generated from field: gitpod.v1.WatchManagedRunnersResponse.EventType event_type = 2;
   */
  eventType = WatchManagedRunnersResponse_EventType.UNSPECIFIED;

  constructor(data?: PartialMessage<WatchManagedRunnersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.WatchManagedRunnersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type", kind: "enum", T: proto3.getEnumType(WatchManagedRunnersResponse_EventType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WatchManagedRunnersResponse {
    return new WatchManagedRunnersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WatchManagedRunnersResponse {
    return new WatchManagedRunnersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WatchManagedRunnersResponse {
    return new WatchManagedRunnersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: WatchManagedRunnersResponse | PlainMessage<WatchManagedRunnersResponse> | undefined, b: WatchManagedRunnersResponse | PlainMessage<WatchManagedRunnersResponse> | undefined): boolean {
    return proto3.util.equals(WatchManagedRunnersResponse, a, b);
  }
}

/**
 * @generated from enum gitpod.v1.WatchManagedRunnersResponse.EventType
 */
export enum WatchManagedRunnersResponse_EventType {
  /**
   * @generated from enum value: EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_TYPE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: EVENT_TYPE_DELETED = 2;
   */
  DELETED = 2,

  /**
   * @generated from enum value: EVENT_TYPE_HIBERNATED = 3;
   */
  HIBERNATED = 3,

  /**
   * @generated from enum value: EVENT_TYPE_WAKE = 4;
   */
  WAKE = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(WatchManagedRunnersResponse_EventType)
proto3.util.setEnumType(WatchManagedRunnersResponse_EventType, "gitpod.v1.WatchManagedRunnersResponse.EventType", [
  { no: 0, name: "EVENT_TYPE_UNSPECIFIED" },
  { no: 1, name: "EVENT_TYPE_CREATED" },
  { no: 2, name: "EVENT_TYPE_DELETED" },
  { no: 3, name: "EVENT_TYPE_HIBERNATED" },
  { no: 4, name: "EVENT_TYPE_WAKE" },
]);

/**
 * @generated from message gitpod.v1.ReportLLMUsageRequest
 */
export class ReportLLMUsageRequest extends Message<ReportLLMUsageRequest> {
  /**
   * Idempotency key to prevent duplicate usage reports
   *
   * @generated from field: string idempotency_key = 1;
   */
  idempotencyKey = "";

  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  /**
   * The model used for the LLM request
   *
   * @generated from field: gitpod.v1.SupportedModel supported_model = 3;
   */
  supportedModel = SupportedModel.UNSPECIFIED;

  /**
   * The LLM integration's ID
   *
   * @generated from field: string llm_integration_id = 4;
   */
  llmIntegrationId = "";

  /**
   * The agent execution ID if this usage is associated with an agent execution
   *
   * @generated from field: string agent_execution_id = 9;
   */
  agentExecutionId = "";

  /**
   * @generated from field: gitpod.v1.LLMUsage usage = 10;
   */
  usage?: LLMUsage;

  constructor(data?: PartialMessage<ReportLLMUsageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportLLMUsageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "idempotency_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "supported_model", kind: "enum", T: proto3.getEnumType(SupportedModel) },
    { no: 4, name: "llm_integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "agent_execution_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "usage", kind: "message", T: LLMUsage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportLLMUsageRequest {
    return new ReportLLMUsageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportLLMUsageRequest {
    return new ReportLLMUsageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportLLMUsageRequest {
    return new ReportLLMUsageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReportLLMUsageRequest | PlainMessage<ReportLLMUsageRequest> | undefined, b: ReportLLMUsageRequest | PlainMessage<ReportLLMUsageRequest> | undefined): boolean {
    return proto3.util.equals(ReportLLMUsageRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.LLMUsage
 */
export class LLMUsage extends Message<LLMUsage> {
  /**
   * Number of input tokens consumed
   *
   * @generated from field: uint64 input_tokens = 1;
   */
  inputTokens = protoInt64.zero;

  /**
   * Number of cached input tokens used
   *
   * @generated from field: uint64 cached_input_tokens = 2;
   */
  cachedInputTokens = protoInt64.zero;

  /**
   * Number of tokens used for cache input creation
   *
   * @generated from field: uint64 cache_input_creation_tokens = 3;
   */
  cacheInputCreationTokens = protoInt64.zero;

  /**
   * Number of output tokens generated
   *
   * @generated from field: uint64 output_tokens = 4;
   */
  outputTokens = protoInt64.zero;

  /**
   * Number of ephemeral 1-hour input tokens used
   *
   * @generated from field: uint64 ephemeral_1h_input_tokens = 5;
   */
  ephemeral1hInputTokens = protoInt64.zero;

  /**
   * Number of ephemeral 5-minute input tokens used
   *
   * @generated from field: uint64 ephemeral_5m_input_tokens = 6;
   */
  ephemeral5mInputTokens = protoInt64.zero;

  constructor(data?: PartialMessage<LLMUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.LLMUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "input_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "cached_input_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "cache_input_creation_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "output_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "ephemeral_1h_input_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "ephemeral_5m_input_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LLMUsage {
    return new LLMUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LLMUsage {
    return new LLMUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LLMUsage {
    return new LLMUsage().fromJsonString(jsonString, options);
  }

  static equals(a: LLMUsage | PlainMessage<LLMUsage> | undefined, b: LLMUsage | PlainMessage<LLMUsage> | undefined): boolean {
    return proto3.util.equals(LLMUsage, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ReportLLMUsageResponse
 */
export class ReportLLMUsageResponse extends Message<ReportLLMUsageResponse> {
  constructor(data?: PartialMessage<ReportLLMUsageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ReportLLMUsageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportLLMUsageResponse {
    return new ReportLLMUsageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportLLMUsageResponse {
    return new ReportLLMUsageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportLLMUsageResponse {
    return new ReportLLMUsageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReportLLMUsageResponse | PlainMessage<ReportLLMUsageResponse> | undefined, b: ReportLLMUsageResponse | PlainMessage<ReportLLMUsageResponse> | undefined): boolean {
    return proto3.util.equals(ReportLLMUsageResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshot
 */
export class RunnerEnvironmentSnapshot extends Message<RunnerEnvironmentSnapshot> {
  /**
   * ID is a unique identifier of this snapshot
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Metadata is data associated with this snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotMetadata metadata = 2;
   */
  metadata?: RunnerEnvironmentSnapshotMetadata;

  /**
   * Spec is the configuration used to create this snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotSpec spec = 3;
   */
  spec?: RunnerEnvironmentSnapshotSpec;

  /**
   * Status is the current status of the snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotStatus status = 4;
   */
  status?: RunnerEnvironmentSnapshotStatus;

  constructor(data?: PartialMessage<RunnerEnvironmentSnapshot>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerEnvironmentSnapshot";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: RunnerEnvironmentSnapshotMetadata },
    { no: 3, name: "spec", kind: "message", T: RunnerEnvironmentSnapshotSpec },
    { no: 4, name: "status", kind: "message", T: RunnerEnvironmentSnapshotStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerEnvironmentSnapshot {
    return new RunnerEnvironmentSnapshot().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshot {
    return new RunnerEnvironmentSnapshot().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshot {
    return new RunnerEnvironmentSnapshot().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerEnvironmentSnapshot | PlainMessage<RunnerEnvironmentSnapshot> | undefined, b: RunnerEnvironmentSnapshot | PlainMessage<RunnerEnvironmentSnapshot> | undefined): boolean {
    return proto3.util.equals(RunnerEnvironmentSnapshot, a, b);
  }
}

/**
 * SnapshotMetadata contains metadata about the snapshot
 *
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshotMetadata
 */
export class RunnerEnvironmentSnapshotMetadata extends Message<RunnerEnvironmentSnapshotMetadata> {
  /**
   * organization_id is the ID of the organization that owns the snapshot
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId = "";

  /**
   * environment_id is the ID of the environment that was snapshotted
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId = "";

  /**
   * environment_spec is the specification of the environment that was snapshotted
   *
   * @generated from field: gitpod.v1.EnvironmentSpec environment_spec = 3;
   */
  environmentSpec?: EnvironmentSpec;

  /**
   * runner_id is the ID of the runner that created the snapshot
   *
   * @generated from field: string runner_id = 4;
   */
  runnerId = "";

  /**
   * created_at is when the snapshot creation was initiated
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * project_id is the ID of the project that the snapshot belongs to
   *
   * @generated from field: optional string project_id = 6;
   */
  projectId?: string;

  constructor(data?: PartialMessage<RunnerEnvironmentSnapshotMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerEnvironmentSnapshotMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "organization_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "environment_spec", kind: "message", T: EnvironmentSpec },
    { no: 4, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerEnvironmentSnapshotMetadata {
    return new RunnerEnvironmentSnapshotMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshotMetadata {
    return new RunnerEnvironmentSnapshotMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshotMetadata {
    return new RunnerEnvironmentSnapshotMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerEnvironmentSnapshotMetadata | PlainMessage<RunnerEnvironmentSnapshotMetadata> | undefined, b: RunnerEnvironmentSnapshotMetadata | PlainMessage<RunnerEnvironmentSnapshotMetadata> | undefined): boolean {
    return proto3.util.equals(RunnerEnvironmentSnapshotMetadata, a, b);
  }
}

/**
 * SnapshotSpec specifies the configuration for creating a snapshot
 *
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshotSpec
 */
export class RunnerEnvironmentSnapshotSpec extends Message<RunnerEnvironmentSnapshotSpec> {
  /**
   * provider_config contains provider-specific configuration
   *
   * @generated from field: map<string, string> provider_config = 1;
   */
  providerConfig: { [key: string]: string } = {};

  /**
   * desired_phase specifies the intended lifecycle phase for this snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotPhase desired_phase = 2;
   */
  desiredPhase = RunnerEnvironmentSnapshotPhase.UNSPECIFIED;

  constructor(data?: PartialMessage<RunnerEnvironmentSnapshotSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerEnvironmentSnapshotSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "provider_config", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 2, name: "desired_phase", kind: "enum", T: proto3.getEnumType(RunnerEnvironmentSnapshotPhase) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerEnvironmentSnapshotSpec {
    return new RunnerEnvironmentSnapshotSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshotSpec {
    return new RunnerEnvironmentSnapshotSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshotSpec {
    return new RunnerEnvironmentSnapshotSpec().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerEnvironmentSnapshotSpec | PlainMessage<RunnerEnvironmentSnapshotSpec> | undefined, b: RunnerEnvironmentSnapshotSpec | PlainMessage<RunnerEnvironmentSnapshotSpec> | undefined): boolean {
    return proto3.util.equals(RunnerEnvironmentSnapshotSpec, a, b);
  }
}

/**
 * SnapshotStatus describes the current status of a snapshot
 *
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshotStatus
 */
export class RunnerEnvironmentSnapshotStatus extends Message<RunnerEnvironmentSnapshotStatus> {
  /**
   * phase is the current phase of the snapshot lifecycle
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotPhase phase = 1;
   */
  phase = RunnerEnvironmentSnapshotPhase.UNSPECIFIED;

  /**
   * size_bytes is the size of the snapshot in bytes (available when completed)
   *
   * @generated from field: int64 size_bytes = 2;
   */
  sizeBytes = protoInt64.zero;

  /**
   * progress contains information about snapshot creation progress
   *
   * @generated from field: int32 completion_percentage = 3;
   */
  completionPercentage = 0;

  /**
   * provider_snapshot contains provider-specific snapshot details
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotStatus.ProviderSnapshot provider_snapshot = 4;
   */
  providerSnapshot?: RunnerEnvironmentSnapshotStatus_ProviderSnapshot;

  /**
   * failure_message contains details about why the snapshot failed
   *
   * @generated from field: string failure_message = 5;
   */
  failureMessage = "";

  /**
   * completed_at is when the snapshot creation was completed (if successful)
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 6;
   */
  completedAt?: Timestamp;

  /**
   * logs_url is the URL to access the environment logs for this snapshot
   *
   * @generated from field: string logs_url = 7;
   */
  logsUrl = "";

  constructor(data?: PartialMessage<RunnerEnvironmentSnapshotStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerEnvironmentSnapshotStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "phase", kind: "enum", T: proto3.getEnumType(RunnerEnvironmentSnapshotPhase) },
    { no: 2, name: "size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "completion_percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "provider_snapshot", kind: "message", T: RunnerEnvironmentSnapshotStatus_ProviderSnapshot },
    { no: 5, name: "failure_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "completed_at", kind: "message", T: Timestamp },
    { no: 7, name: "logs_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerEnvironmentSnapshotStatus {
    return new RunnerEnvironmentSnapshotStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshotStatus {
    return new RunnerEnvironmentSnapshotStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshotStatus {
    return new RunnerEnvironmentSnapshotStatus().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerEnvironmentSnapshotStatus | PlainMessage<RunnerEnvironmentSnapshotStatus> | undefined, b: RunnerEnvironmentSnapshotStatus | PlainMessage<RunnerEnvironmentSnapshotStatus> | undefined): boolean {
    return proto3.util.equals(RunnerEnvironmentSnapshotStatus, a, b);
  }
}

/**
 * ProviderSnapshot contains provider-specific snapshot information
 *
 * @generated from message gitpod.v1.RunnerEnvironmentSnapshotStatus.ProviderSnapshot
 */
export class RunnerEnvironmentSnapshotStatus_ProviderSnapshot extends Message<RunnerEnvironmentSnapshotStatus_ProviderSnapshot> {
  /**
   * provider_snapshot_id is the ID assigned by the cloud provider
   *
   * @generated from field: string provider_snapshot_id = 1;
   */
  providerSnapshotId = "";

  /**
   * provider_name is the name of the cloud provider (e.g., "aws", "gcp", "azure")
   *
   * @generated from field: string provider_name = 2;
   */
  providerName = "";

  /**
   * region is the cloud provider region where the snapshot is stored
   *
   * @generated from field: string region = 3;
   */
  region = "";

  constructor(data?: PartialMessage<RunnerEnvironmentSnapshotStatus_ProviderSnapshot>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.RunnerEnvironmentSnapshotStatus.ProviderSnapshot";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "provider_snapshot_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "provider_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RunnerEnvironmentSnapshotStatus_ProviderSnapshot {
    return new RunnerEnvironmentSnapshotStatus_ProviderSnapshot().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshotStatus_ProviderSnapshot {
    return new RunnerEnvironmentSnapshotStatus_ProviderSnapshot().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RunnerEnvironmentSnapshotStatus_ProviderSnapshot {
    return new RunnerEnvironmentSnapshotStatus_ProviderSnapshot().fromJsonString(jsonString, options);
  }

  static equals(a: RunnerEnvironmentSnapshotStatus_ProviderSnapshot | PlainMessage<RunnerEnvironmentSnapshotStatus_ProviderSnapshot> | undefined, b: RunnerEnvironmentSnapshotStatus_ProviderSnapshot | PlainMessage<RunnerEnvironmentSnapshotStatus_ProviderSnapshot> | undefined): boolean {
    return proto3.util.equals(RunnerEnvironmentSnapshotStatus_ProviderSnapshot, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerEnvironmentSnapshotRequest
 */
export class GetRunnerEnvironmentSnapshotRequest extends Message<GetRunnerEnvironmentSnapshotRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * snapshot_id specifies the snapshot to retrieve
   *
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId = "";

  constructor(data?: PartialMessage<GetRunnerEnvironmentSnapshotRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerEnvironmentSnapshotRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "snapshot_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerEnvironmentSnapshotRequest {
    return new GetRunnerEnvironmentSnapshotRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerEnvironmentSnapshotRequest {
    return new GetRunnerEnvironmentSnapshotRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerEnvironmentSnapshotRequest {
    return new GetRunnerEnvironmentSnapshotRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerEnvironmentSnapshotRequest | PlainMessage<GetRunnerEnvironmentSnapshotRequest> | undefined, b: GetRunnerEnvironmentSnapshotRequest | PlainMessage<GetRunnerEnvironmentSnapshotRequest> | undefined): boolean {
    return proto3.util.equals(GetRunnerEnvironmentSnapshotRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.GetRunnerEnvironmentSnapshotResponse
 */
export class GetRunnerEnvironmentSnapshotResponse extends Message<GetRunnerEnvironmentSnapshotResponse> {
  /**
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshot snapshot = 1;
   */
  snapshot?: RunnerEnvironmentSnapshot;

  constructor(data?: PartialMessage<GetRunnerEnvironmentSnapshotResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.GetRunnerEnvironmentSnapshotResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snapshot", kind: "message", T: RunnerEnvironmentSnapshot },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRunnerEnvironmentSnapshotResponse {
    return new GetRunnerEnvironmentSnapshotResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRunnerEnvironmentSnapshotResponse {
    return new GetRunnerEnvironmentSnapshotResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRunnerEnvironmentSnapshotResponse {
    return new GetRunnerEnvironmentSnapshotResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRunnerEnvironmentSnapshotResponse | PlainMessage<GetRunnerEnvironmentSnapshotResponse> | undefined, b: GetRunnerEnvironmentSnapshotResponse | PlainMessage<GetRunnerEnvironmentSnapshotResponse> | undefined): boolean {
    return proto3.util.equals(GetRunnerEnvironmentSnapshotResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentSnapshotsRequest
 */
export class ListRunnerEnvironmentSnapshotsRequest extends Message<ListRunnerEnvironmentSnapshotsRequest> {
  /**
   * pagination contains the pagination options for listing snapshots
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * The runner's identifier
   *
   * @generated from field: string runner_id = 2;
   */
  runnerId = "";

  /**
   * filter contains the filter options for listing snapshots
   *
   * @generated from field: gitpod.v1.ListRunnerEnvironmentSnapshotsRequest.Filter filter = 3;
   */
  filter?: ListRunnerEnvironmentSnapshotsRequest_Filter;

  constructor(data?: PartialMessage<ListRunnerEnvironmentSnapshotsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerEnvironmentSnapshotsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationRequest },
    { no: 2, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "message", T: ListRunnerEnvironmentSnapshotsRequest_Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerEnvironmentSnapshotsRequest {
    return new ListRunnerEnvironmentSnapshotsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentSnapshotsRequest {
    return new ListRunnerEnvironmentSnapshotsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentSnapshotsRequest {
    return new ListRunnerEnvironmentSnapshotsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerEnvironmentSnapshotsRequest | PlainMessage<ListRunnerEnvironmentSnapshotsRequest> | undefined, b: ListRunnerEnvironmentSnapshotsRequest | PlainMessage<ListRunnerEnvironmentSnapshotsRequest> | undefined): boolean {
    return proto3.util.equals(ListRunnerEnvironmentSnapshotsRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentSnapshotsRequest.Filter
 */
export class ListRunnerEnvironmentSnapshotsRequest_Filter extends Message<ListRunnerEnvironmentSnapshotsRequest_Filter> {
  /**
   * @generated from field: repeated string snapshot_ids = 1;
   */
  snapshotIds: string[] = [];

  constructor(data?: PartialMessage<ListRunnerEnvironmentSnapshotsRequest_Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerEnvironmentSnapshotsRequest.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snapshot_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerEnvironmentSnapshotsRequest_Filter {
    return new ListRunnerEnvironmentSnapshotsRequest_Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentSnapshotsRequest_Filter {
    return new ListRunnerEnvironmentSnapshotsRequest_Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentSnapshotsRequest_Filter {
    return new ListRunnerEnvironmentSnapshotsRequest_Filter().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerEnvironmentSnapshotsRequest_Filter | PlainMessage<ListRunnerEnvironmentSnapshotsRequest_Filter> | undefined, b: ListRunnerEnvironmentSnapshotsRequest_Filter | PlainMessage<ListRunnerEnvironmentSnapshotsRequest_Filter> | undefined): boolean {
    return proto3.util.equals(ListRunnerEnvironmentSnapshotsRequest_Filter, a, b);
  }
}

/**
 * @generated from message gitpod.v1.ListRunnerEnvironmentSnapshotsResponse
 */
export class ListRunnerEnvironmentSnapshotsResponse extends Message<ListRunnerEnvironmentSnapshotsResponse> {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * snapshots are the snapshots that matched the query
   *
   * @generated from field: repeated gitpod.v1.RunnerEnvironmentSnapshot snapshots = 2;
   */
  snapshots: RunnerEnvironmentSnapshot[] = [];

  constructor(data?: PartialMessage<ListRunnerEnvironmentSnapshotsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.ListRunnerEnvironmentSnapshotsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: PaginationResponse },
    { no: 2, name: "snapshots", kind: "message", T: RunnerEnvironmentSnapshot, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListRunnerEnvironmentSnapshotsResponse {
    return new ListRunnerEnvironmentSnapshotsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentSnapshotsResponse {
    return new ListRunnerEnvironmentSnapshotsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListRunnerEnvironmentSnapshotsResponse {
    return new ListRunnerEnvironmentSnapshotsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListRunnerEnvironmentSnapshotsResponse | PlainMessage<ListRunnerEnvironmentSnapshotsResponse> | undefined, b: ListRunnerEnvironmentSnapshotsResponse | PlainMessage<ListRunnerEnvironmentSnapshotsResponse> | undefined): boolean {
    return proto3.util.equals(ListRunnerEnvironmentSnapshotsResponse, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusRequest
 */
export class UpdateRunnerEnvironmentSnapshotStatusRequest extends Message<UpdateRunnerEnvironmentSnapshotStatusRequest> {
  /**
   * The runner's identity
   *
   * @generated from field: string runner_id = 1;
   */
  runnerId = "";

  /**
   * snapshot_id specifies the snapshot to delete
   *
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId = "";

  /**
   * status is the new status for the snapshot
   *
   * @generated from field: gitpod.v1.RunnerEnvironmentSnapshotStatus status = 3;
   */
  status?: RunnerEnvironmentSnapshotStatus;

  constructor(data?: PartialMessage<UpdateRunnerEnvironmentSnapshotStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "runner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "snapshot_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "message", T: RunnerEnvironmentSnapshotStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerEnvironmentSnapshotStatusRequest {
    return new UpdateRunnerEnvironmentSnapshotStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerEnvironmentSnapshotStatusRequest {
    return new UpdateRunnerEnvironmentSnapshotStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerEnvironmentSnapshotStatusRequest {
    return new UpdateRunnerEnvironmentSnapshotStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerEnvironmentSnapshotStatusRequest | PlainMessage<UpdateRunnerEnvironmentSnapshotStatusRequest> | undefined, b: UpdateRunnerEnvironmentSnapshotStatusRequest | PlainMessage<UpdateRunnerEnvironmentSnapshotStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerEnvironmentSnapshotStatusRequest, a, b);
  }
}

/**
 * @generated from message gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusResponse
 */
export class UpdateRunnerEnvironmentSnapshotStatusResponse extends Message<UpdateRunnerEnvironmentSnapshotStatusResponse> {
  constructor(data?: PartialMessage<UpdateRunnerEnvironmentSnapshotStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gitpod.v1.UpdateRunnerEnvironmentSnapshotStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateRunnerEnvironmentSnapshotStatusResponse {
    return new UpdateRunnerEnvironmentSnapshotStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateRunnerEnvironmentSnapshotStatusResponse {
    return new UpdateRunnerEnvironmentSnapshotStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateRunnerEnvironmentSnapshotStatusResponse {
    return new UpdateRunnerEnvironmentSnapshotStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateRunnerEnvironmentSnapshotStatusResponse | PlainMessage<UpdateRunnerEnvironmentSnapshotStatusResponse> | undefined, b: UpdateRunnerEnvironmentSnapshotStatusResponse | PlainMessage<UpdateRunnerEnvironmentSnapshotStatusResponse> | undefined): boolean {
    return proto3.util.equals(UpdateRunnerEnvironmentSnapshotStatusResponse, a, b);
  }
}

